import React, { createContext, useContext, useState, useEffect, useRef } from 'react';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var VeltContext = createContext({ client: null });
function useVeltClient() {
    return useContext(VeltContext);
}

var loadVelt = function (callback, version, staging, develop, proxyDomain) {
    if (version === void 0) { version = 'latest'; }
    if (staging === void 0) { staging = false; }
    if (develop === void 0) { develop = false; }
    var existingScript = document.getElementById('veltScript');
    if (!existingScript) {
        var script = document.createElement('script');
        if (staging) {
            script.src = "https://us-central1-snipply-sdk-staging.cloudfunctions.net/getprivatenpmpackagefile?packageName=sdk-staging&packageVersion=".concat((!version || version === 'latest') ? '1.0.1' : version, "&filePath=velt.js&orgName=@veltdev");
        }
        else if (develop) {
            script.src = "https://us-central1-snipply-sdk-staging.cloudfunctions.net/getprivatenpmpackagefile?packageName=sdk-dev&packageVersion=".concat((!version || version === 'latest') ? '1.0.1' : version, "&filePath=velt.js&orgName=@veltdev");
        }
        else {
            if (proxyDomain) {
                // remove trailing slash from proxy
                if (proxyDomain[proxyDomain.length - 1] === '/') {
                    proxyDomain = proxyDomain.slice(0, -1);
                }
                script.src = "".concat(proxyDomain, "/lib/sdk@").concat(version, "/velt.js");
            }
            else {
                script.src = "https://cdn.jsdelivr.net/npm/@veltdev/sdk@".concat(version, "/velt.js");
            }
        }
        script.id = 'veltScript';
        script.type = 'module';
        document.body.appendChild(script);
        script.onload = function () {
            if (callback) {
                callback();
            }
        };
    }
    else {
        if (callback) {
            callback();
        }
    }
};

var VELT_SDK_VERSION = '1.0.182';
var VELT_SDK_INIT_EVENT = 'onVeltInit';
var VELT_TAB_ID = 'veltTabId';

var SnippylyProvider = function (props) {
    var apiKey = props.apiKey, user = props.user, config = props.config, documentId = props.documentId, language = props.language, translations = props.translations, autoTranslation = props.autoTranslation, onClientLoad = props.onClientLoad, children = props.children;
    var _a = useState(null), client = _a[0], setClient = _a[1];
    useEffect(function () {
        if (apiKey) {
            loadVelt(function () {
                initVelt();
            }, (config === null || config === void 0 ? void 0 : config.version) || VELT_SDK_VERSION, config === null || config === void 0 ? void 0 : config.staging, config === null || config === void 0 ? void 0 : config.develop, config === null || config === void 0 ? void 0 : config.proxyDomain);
        }
    }, []);
    var initVelt = function () { return __awaiter(void 0, void 0, void 0, function () {
        var velt, event;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!config) return [3 /*break*/, 2];
                    if (config.staging) {
                        delete config.staging;
                    }
                    if (config.develop) {
                        delete config.develop;
                    }
                    if (config === null || config === void 0 ? void 0 : config.version) {
                        config === null || config === void 0 ? true : delete config.version;
                    }
                    if (config === null || config === void 0 ? void 0 : config.proxyDomain) {
                        delete config.proxyDomain;
                    }
                    return [4 /*yield*/, ((_a = window.Velt) === null || _a === void 0 ? void 0 : _a.init(apiKey, config))];
                case 1:
                    velt = _c.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, ((_b = window.Velt) === null || _b === void 0 ? void 0 : _b.init(apiKey))];
                case 3:
                    velt = _c.sent();
                    _c.label = 4;
                case 4:
                    // Set language
                    if (language && (velt === null || velt === void 0 ? void 0 : velt.setLanguage)) {
                        velt === null || velt === void 0 ? void 0 : velt.setLanguage(language);
                    }
                    // Set translations
                    if (translations && (velt === null || velt === void 0 ? void 0 : velt.setTranslations)) {
                        if (typeof translations === 'object') {
                            Object.keys(translations).forEach(function (languageCode) {
                                velt === null || velt === void 0 ? void 0 : velt.setTranslations(languageCode, translations[languageCode] || {});
                            });
                        }
                    }
                    if ([true, false].includes(autoTranslation)) {
                        if (autoTranslation && (velt === null || velt === void 0 ? void 0 : velt.enableAutoTranslation)) {
                            velt === null || velt === void 0 ? void 0 : velt.enableAutoTranslation();
                        }
                        else if (!autoTranslation && (velt === null || velt === void 0 ? void 0 : velt.disableAutoTranslation)) {
                            velt === null || velt === void 0 ? void 0 : velt.disableAutoTranslation();
                        }
                    }
                    if (velt === null || velt === void 0 ? void 0 : velt.st) {
                        velt === null || velt === void 0 ? void 0 : velt.st('react');
                    }
                    setClient(velt);
                    if (onClientLoad) {
                        onClientLoad(velt);
                    }
                    if (!user) return [3 /*break*/, 6];
                    return [4 /*yield*/, (velt === null || velt === void 0 ? void 0 : velt.identify(user))];
                case 5:
                    _c.sent();
                    _c.label = 6;
                case 6:
                    if (documentId) {
                        velt === null || velt === void 0 ? void 0 : velt.setDocumentId(documentId);
                    }
                    event = new CustomEvent(VELT_SDK_INIT_EVENT, { detail: velt });
                    window.dispatchEvent(event);
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement(VeltContext.Provider, { value: { client: client } }, children)));
};

var SnippylyCommentBubble = function (props) {
    var targetCommentElementId = props.targetCommentElementId, avatar = props.avatar, showAvatar = props.showAvatar, commentBubbleTargetPinHover = props.commentBubbleTargetPinHover, children = props.children, shadowDom = props.shadowDom, variant = props.variant, darkMode = props.darkMode, commentCountType = props.commentCountType;
    return (React.createElement("velt-comment-bubble", { "comment-count-type": commentCountType, "target-comment-element-id": targetCommentElementId, "show-avatar": [true, false].includes(showAvatar) ? (showAvatar ? 'true' : 'false') : undefined, avatar: [true, false].includes(avatar) ? (avatar ? 'true' : 'false') : undefined, "comment-bubble-target-pin-hover": commentBubbleTargetPinHover ? 'true' : undefined, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined, variant: variant }, children));
};

var SnippylyComments = function (props) {
    var autoCategorize = props.autoCategorize, streamViewContainerId = props.streamViewContainerId, onSignIn = props.onSignIn, onUpgrade = props.onUpgrade, textMode = props.textMode, popoverMode = props.popoverMode, popoverTriangleComponent = props.popoverTriangleComponent, floatingCommentDialog = props.floatingCommentDialog, moderatorMode = props.moderatorMode, streamMode = props.streamMode, signInButton = props.signInButton, upgradeButton = props.upgradeButton, attachments = props.attachments, recordings = props.recordings, reactions = props.reactions, deviceInfo = props.deviceInfo, commentIndex = props.commentIndex, dialogOnHover = props.dialogOnHover, dialogOnTargetElementClick = props.dialogOnTargetElementClick, priority = props.priority, inboxMode = props.inboxMode, suggestionMode = props.suggestionMode, mobileMode = props.mobileMode, inlineCommentMode = props.inlineCommentMode, privateCommentMode = props.privateCommentMode, minimap = props.minimap, persistentCommentMode = props.persistentCommentMode, ghostComments = props.ghostComments, ghostCommentsIndicator = props.ghostCommentsIndicator, commentsOnDom = props.commentsOnDom, resolvedCommentsOnDom = props.resolvedCommentsOnDom, commentTool = props.commentTool, sidebarButtonOnCommentDialog = props.sidebarButtonOnCommentDialog, deviceIndicatorOnCommentPins = props.deviceIndicatorOnCommentPins, scrollToComment = props.scrollToComment, userMentions = props.userMentions, deleteOnBackspace = props.deleteOnBackspace, hotkey = props.hotkey, recordingSummary = props.recordingSummary, recordingCountdown = props.recordingCountdown, unreadIndicatorMode = props.unreadIndicatorMode, enterKeyToSubmit = props.enterKeyToSubmit, pinShadowDom = props.pinShadowDom, dialogShadowDom = props.dialogShadowDom, shadowDom = props.shadowDom, changeDetectionInCommentMode = props.changeDetectionInCommentMode, allowedElementIds = props.allowedElementIds, allowedElementClassNames = props.allowedElementClassNames, allowedElementQuerySelectors = props.allowedElementQuerySelectors, commentPinHighlighter = props.commentPinHighlighter, customReactions = props.customReactions, onCommentAdd = props.onCommentAdd, onCommentUpdate = props.onCommentUpdate, onCommentAccept = props.onCommentAccept, onCommentReject = props.onCommentReject, onSidebarButtonOnCommentDialogClick = props.onSidebarButtonOnCommentDialogClick, onCommentSelectionChange = props.onCommentSelectionChange, customStatus = props.customStatus, customPriority = props.customPriority, customCategory = props.customCategory, status = props.status, resolveButton = props.resolveButton, darkMode = props.darkMode, onCustomPinInject = props.onCustomPinInject, children = props.children, textCommentToolShadowDom = props.textCommentToolShadowDom, textCommentToolbarShadowDom = props.textCommentToolbarShadowDom, dialogDarkMode = props.dialogDarkMode, pinDarkMode = props.pinDarkMode, textCommentToolDarkMode = props.textCommentToolDarkMode, textCommentToolbarDarkMode = props.textCommentToolbarDarkMode, composerMode = props.composerMode;
    var ref = useRef();
    var onSignInRef = useRef(onSignIn);
    var onUpgradeRef = useRef(onUpgrade);
    var onCommentAddRef = useRef(onCommentAdd);
    var onCommentUpdateRef = useRef(onCommentUpdate);
    var onCommentAcceptRef = useRef(onCommentAccept);
    var onCommentRejectRef = useRef(onCommentReject);
    var onSidebarButtonOnCommentDialogClickRef = useRef(onSidebarButtonOnCommentDialogClick);
    var onCustomPinInjectRef = useRef(onCustomPinInject);
    var onCommentSelectionChangeRef = useRef(onCommentSelectionChange);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        onSignInRef.current = onSignIn;
    }, [onSignIn]);
    useEffect(function () {
        onUpgradeRef.current = onUpgrade;
    }, [onUpgrade]);
    useEffect(function () {
        onCommentAddRef.current = onCommentAdd;
    }, [onCommentAdd]);
    useEffect(function () {
        onCommentUpdateRef.current = onCommentUpdate;
    }, [onCommentUpdate]);
    useEffect(function () {
        onCommentAcceptRef.current = onCommentAccept;
    }, [onCommentAccept]);
    useEffect(function () {
        onCommentRejectRef.current = onCommentReject;
    }, [onCommentReject]);
    useEffect(function () {
        onSidebarButtonOnCommentDialogClickRef.current = onSidebarButtonOnCommentDialogClick;
    }, [onSidebarButtonOnCommentDialogClick]);
    useEffect(function () {
        onCustomPinInjectRef.current = onCustomPinInject;
    }, [onCustomPinInject]);
    useEffect(function () {
        onCommentSelectionChangeRef.current = onCommentSelectionChange;
    }, [onCommentSelectionChange]);
    useEffect(function () {
        if (ref.current) {
            var element = ref.current;
            element.addEventListener('onSignIn', function (event) {
                if (onSignInRef.current) {
                    onSignInRef.current(event === null || event === void 0 ? void 0 : event.detail);
                }
            });
            element.addEventListener('onUpgrade', function (event) {
                if (onUpgradeRef.current) {
                    onUpgradeRef.current(event === null || event === void 0 ? void 0 : event.detail);
                }
            });
            element.addEventListener('onCommentAdd', function (event) {
                if (onCommentAddRef.current) {
                    onCommentAddRef.current(event === null || event === void 0 ? void 0 : event.detail);
                }
            });
            element.addEventListener('onCommentUpdate', function (event) {
                if (onCommentUpdateRef.current) {
                    onCommentUpdateRef.current(event === null || event === void 0 ? void 0 : event.detail);
                }
            });
            element.addEventListener('onCommentAccept', function (event) {
                if (onCommentAcceptRef.current) {
                    onCommentAcceptRef.current(event === null || event === void 0 ? void 0 : event.detail);
                }
            });
            element.addEventListener('onCommentReject', function (event) {
                if (onCommentRejectRef.current) {
                    onCommentRejectRef.current(event === null || event === void 0 ? void 0 : event.detail);
                }
            });
            element.addEventListener('onSidebarButtonOnCommentDialogClick', function (event) {
                if (onSidebarButtonOnCommentDialogClickRef.current) {
                    onSidebarButtonOnCommentDialogClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
                }
            });
            element.addEventListener('onCustomPinInject', function (event) {
                if (onCustomPinInjectRef.current) {
                    onCustomPinInjectRef.current(event === null || event === void 0 ? void 0 : event.detail);
                }
            });
            element.addEventListener('onCommentSelectionChange', function (event) {
                if (onCommentSelectionChangeRef.current) {
                    onCommentSelectionChangeRef.current(event === null || event === void 0 ? void 0 : event.detail);
                }
            });
        }
    }, []);
    return (React.createElement("velt-comments", { ref: ref, "composer-mode": composerMode, "auto-categorize": [true, false].includes(autoCategorize) ? (autoCategorize ? 'true' : 'false') : undefined, "data-stream-view-container-id": streamViewContainerId, "text-mode": [true, false].includes(textMode) ? (textMode ? 'true' : 'false') : undefined, "popover-mode": [true, false].includes(popoverMode) ? (popoverMode ? 'true' : 'false') : undefined, "popover-triangle-component": [true, false].includes(popoverTriangleComponent) ? (popoverTriangleComponent ? 'true' : 'false') : undefined, "floating-comment-dialog": [true, false].includes(floatingCommentDialog) ? (floatingCommentDialog ? 'true' : 'false') : undefined, "moderator-mode": [true, false].includes(moderatorMode) ? (moderatorMode ? 'true' : 'false') : undefined, "stream-mode": [true, false].includes(streamMode) ? (streamMode ? 'true' : 'false') : undefined, "sign-in-button": [true, false].includes(signInButton) ? (signInButton ? 'true' : 'false') : undefined, "upgrade-button": [true, false].includes(upgradeButton) ? (upgradeButton ? 'true' : 'false') : undefined, attachments: [true, false].includes(attachments) ? (attachments ? 'true' : 'false') : undefined, recordings: recordings, reactions: [true, false].includes(reactions) ? (reactions ? 'true' : 'false') : undefined, "device-info": [true, false].includes(deviceInfo) ? (deviceInfo ? 'true' : 'false') : undefined, "comment-index": [true, false].includes(commentIndex) ? (commentIndex ? 'true' : 'false') : undefined, "dialog-on-hover": [true, false].includes(dialogOnHover) ? (dialogOnHover ? 'true' : 'false') : undefined, "dialog-on-target-element-click": [true, false].includes(dialogOnTargetElementClick) ? (dialogOnTargetElementClick ? 'true' : 'false') : undefined, priority: [true, false].includes(priority) ? (priority ? 'true' : 'false') : undefined, status: [true, false].includes(status) ? (status ? 'true' : 'false') : undefined, "resolve-button": [true, false].includes(resolveButton) ? (resolveButton ? 'true' : 'false') : undefined, "inbox-mode": [true, false].includes(inboxMode) ? (inboxMode ? 'true' : 'false') : undefined, "suggestion-mode": [true, false].includes(suggestionMode) ? (suggestionMode ? 'true' : 'false') : undefined, "mobile-mode": [true, false].includes(mobileMode) ? (mobileMode ? 'true' : 'false') : undefined, "inline-comment-mode": [true, false].includes(inlineCommentMode) ? (inlineCommentMode ? 'true' : 'false') : undefined, "private-comment-mode": [true, false].includes(privateCommentMode) ? (privateCommentMode ? 'true' : 'false') : undefined, minimap: [true, false].includes(minimap) ? (minimap ? 'true' : 'false') : undefined, "persistent-comment-mode": [true, false].includes(persistentCommentMode) ? (persistentCommentMode ? 'true' : 'false') : undefined, "ghost-comments": [true, false].includes(ghostComments) ? (ghostComments ? 'true' : 'false') : undefined, "ghost-comments-indicator": [true, false].includes(ghostCommentsIndicator) ? (ghostCommentsIndicator ? 'true' : 'false') : undefined, "comments-on-dom": [true, false].includes(commentsOnDom) ? (commentsOnDom ? 'true' : 'false') : undefined, "resolved-comments-on-dom": [true, false].includes(resolvedCommentsOnDom) ? (resolvedCommentsOnDom ? 'true' : 'false') : undefined, "comment-tool": [true, false].includes(commentTool) ? (commentTool ? 'true' : 'false') : undefined, "sidebar-button-on-comment-dialog": [true, false].includes(sidebarButtonOnCommentDialog) ? (sidebarButtonOnCommentDialog ? 'true' : 'false') : undefined, "device-indicator-on-comment-pins": [true, false].includes(deviceIndicatorOnCommentPins) ? (deviceIndicatorOnCommentPins ? 'true' : 'false') : undefined, "scroll-to-comment": [true, false].includes(scrollToComment) ? (scrollToComment ? 'true' : 'false') : undefined, "user-mentions": [true, false].includes(userMentions) ? (userMentions ? 'true' : 'false') : undefined, "delete-on-backspace": [true, false].includes(deleteOnBackspace) ? (deleteOnBackspace ? 'true' : 'false') : undefined, hotkey: [true, false].includes(hotkey) ? (hotkey ? 'true' : 'false') : undefined, "recording-summary": [true, false].includes(recordingSummary) ? (recordingSummary ? 'true' : 'false') : undefined, "recording-countdown": [true, false].includes(recordingCountdown) ? (recordingCountdown ? 'true' : 'false') : undefined, "unread-indicator-mode": unreadIndicatorMode, "enter-key-to-submit": [true, false].includes(enterKeyToSubmit) ? (enterKeyToSubmit ? 'true' : 'false') : undefined, "pin-shadow-dom": [true, false].includes(pinShadowDom) ? (pinShadowDom ? 'true' : 'false') : undefined, "dialog-shadow-dom": [true, false].includes(dialogShadowDom) ? (dialogShadowDom ? 'true' : 'false') : undefined, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "text-comment-tool-shadow-dom": [true, false].includes(textCommentToolShadowDom) ? (textCommentToolShadowDom ? 'true' : 'false') : undefined, "text-comment-toolbar-shadow-dom": [true, false].includes(textCommentToolbarShadowDom) ? (textCommentToolbarShadowDom ? 'true' : 'false') : undefined, "change-detection-in-comment-mode": [true, false].includes(changeDetectionInCommentMode) ? (changeDetectionInCommentMode ? 'true' : 'false') : undefined, "allowed-element-ids": JSON.stringify(allowedElementIds), "allowed-element-class-names": JSON.stringify(allowedElementClassNames), "allowed-element-query-selectors": JSON.stringify(allowedElementQuerySelectors), "comment-pin-highlighter": [true, false].includes(commentPinHighlighter) ? (commentPinHighlighter ? 'true' : 'false') : undefined, "custom-reactions": JSON.stringify(customReactions), "custom-status": JSON.stringify(customStatus), "custom-priority": JSON.stringify(customPriority), "custom-category": JSON.stringify(customCategory), "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined, "dialog-dark-mode": [true, false].includes(dialogDarkMode) ? (dialogDarkMode ? 'true' : 'false') : undefined, "pin-dark-mode": [true, false].includes(pinDarkMode) ? (pinDarkMode ? 'true' : 'false') : undefined, "text-comment-tool-dark-mode": [true, false].includes(textCommentToolDarkMode) ? (textCommentToolDarkMode ? 'true' : 'false') : undefined, "text-comment-toolbar-dark-mode": [true, false].includes(textCommentToolbarDarkMode) ? (textCommentToolbarDarkMode ? 'true' : 'false') : undefined }, children));
};

var SnippylyCommentsSidebar = function (props) {
    var embedMode = props.embedMode, enableUrlNavigation = props.enableUrlNavigation, urlNavigation = props.urlNavigation, pageMode = props.pageMode, currentLocationSuffix = props.currentLocationSuffix, sortData = props.sortData, filterConfig = props.filterConfig, groupConfig = props.groupConfig, filters = props.filters, variant = props.variant, pageModeComposerVariant = props.pageModeComposerVariant, dialogVariant = props.dialogVariant, shadowDom = props.shadowDom, openSidebar = props.openSidebar, onSidebarOpen = props.onSidebarOpen, onSidebarCommentClick = props.onSidebarCommentClick, onCommentClick = props.onCommentClick, darkMode = props.darkMode;
    var ref = useRef();
    var openSidebarRef = useRef(openSidebar);
    var onSidebarOpenRef = useRef(onSidebarOpen);
    var onSidebarCommentClickRef = useRef(onSidebarCommentClick);
    var onCommentClickRef = useRef(onCommentClick);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        openSidebarRef.current = openSidebar;
    }, [openSidebar]);
    useEffect(function () {
        onSidebarOpenRef.current = onSidebarOpen;
    }, [onSidebarOpen]);
    useEffect(function () {
        onSidebarCommentClickRef.current = onSidebarCommentClick;
    }, [onSidebarCommentClick]);
    useEffect(function () {
        onCommentClickRef.current = onCommentClick;
    }, [onCommentClick]);
    useEffect(function () {
        if (ref.current) {
            var element = ref.current;
            element.addEventListener('onSidebarOpen', function (event) {
                if (openSidebarRef.current) {
                    openSidebarRef.current(event === null || event === void 0 ? void 0 : event.detail);
                }
                if (onSidebarOpenRef.current) {
                    onSidebarOpenRef.current(event === null || event === void 0 ? void 0 : event.detail);
                }
            });
            element.addEventListener('onSidebarCommentClick', function (event) {
                if (onSidebarCommentClickRef.current) {
                    onSidebarCommentClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
                }
                if (onCommentClickRef.current) {
                    onCommentClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
                }
            });
        }
    }, []);
    return (React.createElement("velt-comments-sidebar", { ref: ref, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "embed-mode": [true, false].includes(embedMode) ? (embedMode ? 'true' : 'false') : undefined, "enable-url-navigation": [true, false].includes(enableUrlNavigation) ? (enableUrlNavigation ? 'true' : 'false') : undefined, "url-navigation": [true, false].includes(urlNavigation) ? (urlNavigation ? 'true' : 'false') : undefined, "page-mode": [true, false].includes(pageMode) ? (pageMode ? 'true' : 'false') : undefined, "current-location-suffix": [true, false].includes(currentLocationSuffix) ? (currentLocationSuffix ? 'true' : 'false') : undefined, "filter-config": filterConfig ? JSON.stringify(filterConfig) : undefined, "group-config": groupConfig ? JSON.stringify(groupConfig) : undefined, filters: filters ? JSON.stringify(filters) : undefined, variant: variant, "page-mode-composer-variant": pageModeComposerVariant, "dialog-variant": dialogVariant, "sort-data": sortData, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined }));
};

var SnippylyCommentTool = function (props) {
    var targetCommentElementId = props.targetCommentElementId, onCommentModeChange = props.onCommentModeChange, children = props.children, darkMode = props.darkMode, variant = props.variant, shadowDom = props.shadowDom;
    var ref = useRef();
    var onCommentModeChangeRef = useRef(onCommentModeChange);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        onCommentModeChangeRef.current = onCommentModeChange;
    }, [onCommentModeChange]);
    useEffect(function () {
        if (ref.current) {
            var element = ref.current;
            element.addEventListener('onCommentModeChange', function (event) {
                if (onCommentModeChangeRef.current) {
                    onCommentModeChangeRef.current(event === null || event === void 0 ? void 0 : event.detail);
                }
            });
        }
    }, []);
    return (React.createElement("velt-comment-tool", { ref: ref, "target-comment-element-id": targetCommentElementId, variant: variant, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined }, children));
};

var SnippylyCursor = function (props) {
    var allowedElementIds = props.allowedElementIds, avatarMode = props.avatarMode, inactivityTime = props.inactivityTime, onCursorUsersChanged = props.onCursorUsersChanged, onCursorUserChange = props.onCursorUserChange, children = props.children;
    var ref = useRef();
    var onCursorUsersChangedRef = useRef(onCursorUsersChanged);
    var onCursorUserChangeRef = useRef(onCursorUserChange);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        onCursorUsersChangedRef.current = onCursorUsersChanged;
    }, [onCursorUsersChanged]);
    useEffect(function () {
        onCursorUserChangeRef.current = onCursorUserChange;
    }, [onCursorUserChange]);
    useEffect(function () {
        if (ref.current) {
            var element = ref.current;
            element.addEventListener('onCursorUserChange', function (event) {
                if (onCursorUsersChangedRef.current) {
                    onCursorUsersChangedRef.current(event === null || event === void 0 ? void 0 : event.detail);
                }
                if (onCursorUserChangeRef.current) {
                    onCursorUserChangeRef.current(event === null || event === void 0 ? void 0 : event.detail);
                }
            });
        }
    }, []);
    return (React.createElement("velt-cursor", { ref: ref, "allowed-element-ids": allowedElementIds, "avatar-mode": avatarMode ? 'true' : undefined, "inactivity-time": inactivityTime }, children));
};

var SnippylyHuddle = function (props) {
    var chat = props.chat, flockModeOnAvatarClick = props.flockModeOnAvatarClick;
    return (React.createElement("velt-huddle", { chat: [true, false].includes(chat) ? (chat ? 'true' : 'false') : undefined, "flock-mode-on-avatar-click": [true, false].includes(flockModeOnAvatarClick) ? (flockModeOnAvatarClick ? 'true' : 'false') : undefined }));
};

var SnippylyHuddleTool = function (props) {
    var type = props.type, children = props.children, darkMode = props.darkMode;
    return (React.createElement("velt-huddle-tool", { type: type, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined }, children));
};

var SnippylyPresence = function (props) {
    var maxUsers = props.maxUsers, inactivityTime = props.inactivityTime, documentParams = props.documentParams, location = props.location, self = props.self, onPresenceUserClick = props.onPresenceUserClick, onUsersChanged = props.onUsersChanged, onPresenceUserChange = props.onPresenceUserChange, disableFlockNavigation = props.disableFlockNavigation, defaultFlockNavigation = props.defaultFlockNavigation, onNavigate = props.onNavigate, flockMode = props.flockMode;
    var ref = useRef();
    var onUsersChangedRef = useRef(onUsersChanged);
    var onPresenceUserChangeRef = useRef(onPresenceUserChange);
    var onNavigateRef = useRef(onNavigate);
    var onPresenceUserClickRef = useRef(onPresenceUserClick);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        onUsersChangedRef.current = onUsersChanged;
    }, [onUsersChanged]);
    useEffect(function () {
        onPresenceUserChangeRef.current = onPresenceUserChange;
    }, [onPresenceUserChange]);
    useEffect(function () {
        onNavigateRef.current = onNavigate;
    }, [onNavigate]);
    useEffect(function () {
        onPresenceUserClickRef.current = onPresenceUserClick;
    }, [onPresenceUserClick]);
    useEffect(function () {
        if (ref.current) {
            var element = ref.current;
            element.addEventListener('onPresenceUserChange', function (event) {
                if (onUsersChangedRef.current) {
                    onUsersChangedRef.current(event === null || event === void 0 ? void 0 : event.detail);
                }
                if (onPresenceUserChangeRef.current) {
                    onPresenceUserChangeRef.current(event === null || event === void 0 ? void 0 : event.detail);
                }
            });
            element.addEventListener('onNavigate', function (event) {
                if (onNavigateRef.current) {
                    onNavigateRef.current(event === null || event === void 0 ? void 0 : event.detail);
                }
            });
            element.addEventListener('onPresenceUserClick', function (event) {
                if (onPresenceUserClickRef.current) {
                    onPresenceUserClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
                }
            });
        }
    }, []);
    return (React.createElement("velt-presence", { ref: ref, "flock-mode": [true, false].includes(flockMode) ? (flockMode ? 'true' : 'false') : undefined, "max-users": maxUsers, "inactivity-time": inactivityTime, "document-params": (typeof documentParams === 'object') ? JSON.stringify(documentParams) : (documentParams ? documentParams : undefined), "disable-flock-navigation": [true, false].includes(disableFlockNavigation) ? (disableFlockNavigation ? 'true' : 'false') : undefined, "default-flock-navigation": [true, false].includes(defaultFlockNavigation) ? (defaultFlockNavigation ? 'true' : 'false') : undefined, self: [true, false].includes(self) ? (self ? 'true' : 'false') : undefined, location: (typeof location === 'object') ? JSON.stringify(location) : (location ? location : undefined) }));
};

var SnippylyRecorderControlPanel = function (props) {
    var mode = props.mode, panelId = props.panelId, onRecordedData = props.onRecordedData;
    var ref = useRef();
    var onRecordedDataRef = useRef(onRecordedData);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        onRecordedDataRef.current = onRecordedData;
    }, [onRecordedData]);
    useEffect(function () {
        if (ref.current) {
            var element = ref.current;
            element.addEventListener('onRecordedData', function (event) {
                if (onRecordedDataRef.current) {
                    onRecordedDataRef.current(event === null || event === void 0 ? void 0 : event.detail);
                }
            });
        }
    }, []);
    return (React.createElement("velt-recorder-control-panel", { ref: ref, mode: mode, "panel-id": panelId }));
};

var SnippylyRecorderNotes = function (props) {
    return (React.createElement("velt-recorder-notes", null));
};

var SnippylyRecorderPlayer = function (props) {
    var recorderId = props.recorderId, onDelete = props.onDelete, showSummary = props.showSummary, summary = props.summary;
    var ref = useRef();
    var onDeleteRef = useRef(onDelete);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        onDeleteRef.current = onDelete;
    }, [onDelete]);
    useEffect(function () {
        if (ref.current) {
            var element = ref.current;
            element === null || element === void 0 ? void 0 : element.addEventListener('onDelete', function (event) {
                if (onDeleteRef.current) {
                    onDeleteRef.current(event === null || event === void 0 ? void 0 : event.detail);
                }
            });
        }
    }, []);
    return (React.createElement("velt-recorder-player", { ref: ref, "recorder-id": recorderId, "show-summary": [true, false].includes(showSummary) ? (showSummary ? 'true' : 'false') : undefined, summary: [true, false].includes(summary) ? (summary ? 'true' : 'false') : undefined }));
};

var SnippylyRecorderTool = function (props) {
    var type = props.type, panelId = props.panelId, buttonLabel = props.buttonLabel, children = props.children, darkMode = props.darkMode;
    return (React.createElement("velt-recorder-tool", { type: type, "panel-id": panelId, "button-label": buttonLabel, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined }, children));
};

var SnippylySidebarButton = function (props) {
    var tooltipText = props.tooltipText, children = props.children, darkMode = props.darkMode, shadowDom = props.shadowDom;
    return (React.createElement("velt-sidebar-button", { "tooltip-text": tooltipText, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined }, children));
};

var SnippylyTags = function (props) {
    var pinHighlighterClass = props.pinHighlighterClass;
    return (React.createElement("velt-tags", { "pin-highlighter-class": pinHighlighterClass }));
};

var SnippylyTagTool = function (props) {
    var targetTagElementId = props.targetTagElementId, children = props.children;
    return (React.createElement("velt-tag-tool", { "target-tag-element-id": targetTagElementId }, children));
};

var SnippylyArrows = function () {
    return (React.createElement("velt-arrows", null));
};

var SnippylyArrowTool = function (props) {
    var children = props.children, darkMode = props.darkMode;
    return (React.createElement("velt-arrow-tool", { "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined }, children));
};

var SnippylyUserInviteTool = function (props) {
    var type = props.type, source = props.source, title = props.title, placeholder = props.placeholder, inviteUrl = props.inviteUrl, accessControlDropdown = props.accessControlDropdown, documentUserAccessList = props.documentUserAccessList, children = props.children, darkMode = props.darkMode;
    return (React.createElement("velt-user-invite-tool", { type: type, source: source, title: title, placeholder: placeholder, "invite-url": inviteUrl, "access-control-dropdown": [true, false].includes(accessControlDropdown) ? accessControlDropdown : undefined, "document-user-access-list": [true, false].includes(documentUserAccessList) ? documentUserAccessList : undefined, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined }, children));
};

var SnippylyUserRequestTool = function (props) {
    var type = props.type;
    return (React.createElement("velt-user-request-tool", { type: type }));
};

var VeltCommentPlayerTimeline = function (props) {
    var totalMediaLength = props.totalMediaLength, onCommentClick = props.onCommentClick, shadowDom = props.shadowDom;
    var ref = useRef();
    var onCommentClickRef = useRef(onCommentClick);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        onCommentClickRef.current = onCommentClick;
    }, [onCommentClick]);
    useEffect(function () {
        if (ref.current) {
            var element = ref.current;
            element.addEventListener('onCommentClick', function (event) {
                if (onCommentClickRef.current) {
                    onCommentClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
                }
            });
        }
    }, []);
    return (React.createElement("velt-comment-player-timeline", { ref: ref, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "total-media-length": totalMediaLength }));
};

var VeltVideoPlayer = function (props) {
    var darkMode = props.darkMode, src = props.src, sync = props.sync, commentTool = props.commentTool, shadowDom = props.shadowDom;
    return (React.createElement("velt-video-player", { "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, src: src, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined, sync: [true, false].includes(sync) ? (sync ? 'true' : 'false') : undefined, "comment-tool": [true, false].includes(commentTool) ? (commentTool ? 'true' : 'false') : undefined }));
};

var VeltViewAnalytics = function (props) {
    var type = props.type, locationId = props.locationId;
    return (React.createElement("velt-view-analytics", { type: type, "location-id": locationId }));
};

var VeltCommentThread = function (props) {
    var annotationId = props.annotationId;
    return (React.createElement("velt-comment-thread", { "annotation-id": annotationId }));
};

var VeltNotificationsTool = function (props) {
    var children = props.children, darkMode = props.darkMode, onNotificationClick = props.onNotificationClick, shadowDom = props.shadowDom, panelShadowDom = props.panelShadowDom;
    var ref = useRef();
    var onNotificationClickRef = useRef(onNotificationClick);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        onNotificationClickRef.current = onNotificationClick;
    }, [onNotificationClick]);
    useEffect(function () {
        if (ref.current) {
            var element = ref.current;
            element.addEventListener('onNotificationClick', function (event) {
                if (onNotificationClickRef.current) {
                    onNotificationClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
                }
            });
        }
    }, []);
    return (React.createElement("velt-notifications-tool", { ref: ref, "panel-shadow-dom": [true, false].includes(panelShadowDom) ? (panelShadowDom ? 'true' : 'false') : undefined, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined }, children));
};

var VeltNotificationsPanel = function (props) {
    var darkMode = props.darkMode, onNotificationClick = props.onNotificationClick, shadowDom = props.shadowDom;
    var ref = useRef();
    var onNotificationClickRef = useRef(onNotificationClick);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        onNotificationClickRef.current = onNotificationClick;
    }, [onNotificationClick]);
    useEffect(function () {
        if (ref.current) {
            var element = ref.current;
            element.addEventListener('onNotificationClick', function (event) {
                if (onNotificationClickRef.current) {
                    onNotificationClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
                }
            });
        }
    }, []);
    return (React.createElement("velt-notifications-panel", { ref: ref, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined }));
};

var VeltNotificationsHistoryPanel = function (props) {
    var embedMode = props.embedMode, darkMode = props.darkMode, onNotificationClick = props.onNotificationClick;
    var ref = useRef();
    var onNotificationClickRef = useRef(onNotificationClick);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        onNotificationClickRef.current = onNotificationClick;
    }, [onNotificationClick]);
    useEffect(function () {
        if (ref.current) {
            var element = ref.current;
            element.addEventListener('onNotificationClick', function (event) {
                if (onNotificationClickRef.current) {
                    onNotificationClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
                }
            });
        }
    }, []);
    return (React.createElement("velt-notifications-history-panel", { ref: ref, "embed-mode": [true, false].includes(embedMode) ? (embedMode ? 'true' : 'false') : undefined, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined }));
};

var VeltChartComment = function (props) {
    var commentMetadata = props.commentMetadata, dialogMetadataTemplate = props.dialogMetadataTemplate, children = props.children, ghostComment = props.ghostComment;
    return (React.createElement("velt-chart-comment", { "comment-metadata": commentMetadata ? JSON.stringify(commentMetadata) : undefined, "dialog-metadata-template": (dialogMetadataTemplate === null || dialogMetadataTemplate === void 0 ? void 0 : dialogMetadataTemplate.length) ? JSON.stringify(dialogMetadataTemplate) : undefined, "ghost-comment": [true, false].includes(ghostComment) ? (ghostComment ? 'true' : 'false') : undefined }, children));
};

var VeltNivoChartComments = function (_a) {
    var _b, _c, _d, _e, _f;
    var chartComputedData = _a.chartComputedData, dialogMetadataTemplate = _a.dialogMetadataTemplate, id = _a.id;
    var client = useVeltClient().client;
    var _g = React.useState({ comments: [] }), ghostCommentsData = _g[0], setGhostCommentsData = _g[1];
    var _h = React.useState(null), documentPathsSubscription = _h[0], setDocumentPathsSubscription = _h[1];
    var _j = React.useState(null), commentSubscription = _j[0], setCommentSubscription = _j[1];
    // Unsubscribe from the subscriptions when the component is unmounted
    useEffect(function () {
        return function () {
            unsubscribeDocumentPathsSubscription();
            unsubscribeCommentSubscription();
        };
    }, []);
    useEffect(function () {
        getCommentAnnotations();
    }, [chartComputedData === null || chartComputedData === void 0 ? void 0 : chartComputedData.data]);
    useEffect(function () {
        if (client) {
            getCommentAnnotations();
        }
    }, [client]);
    var getCommentAnnotations = function () {
        var _a;
        try {
            unsubscribeDocumentPathsSubscription();
            unsubscribeCommentSubscription();
            if (client) {
                var subscription = (_a = client === null || client === void 0 ? void 0 : client.docService) === null || _a === void 0 ? void 0 : _a.getDocumentPaths$().subscribe(function (paths) {
                    var _a;
                    if (paths === null || paths === void 0 ? void 0 : paths.clientDocumentId) {
                        unsubscribeCommentSubscription();
                        var commentElement = client.getCommentElement();
                        var subscription_1 = (_a = commentElement === null || commentElement === void 0 ? void 0 : commentElement.getAllCommentAnnotations(paths === null || paths === void 0 ? void 0 : paths.clientDocumentId)) === null || _a === void 0 ? void 0 : _a.subscribe(function (comments) {
                            filterGhostComments(comments);
                        });
                        setCommentSubscription(subscription_1);
                    }
                });
                setDocumentPathsSubscription(subscription);
            }
        }
        catch (err) {
        }
    };
    var filterGhostComments = function (comments) {
        var _a, _b, _c;
        try {
            var chartComments = (_a = comments === null || comments === void 0 ? void 0 : comments.filter(function (annotation) { return annotation.commentType === 'chart'; })) === null || _a === void 0 ? void 0 : _a.filter(function (annotation) { var _a; return ((_a = annotation === null || annotation === void 0 ? void 0 : annotation.metadata) === null || _a === void 0 ? void 0 : _a.id) === id; });
            if ((_b = chartComputedData === null || chartComputedData === void 0 ? void 0 : chartComputedData.bars) === null || _b === void 0 ? void 0 : _b.length) {
                var ghostComments_1 = [];
                chartComments.forEach(function (annotation) {
                    var _a;
                    var metadata = annotation.metadata;
                    var groupId = metadata === null || metadata === void 0 ? void 0 : metadata.groupId;
                    var value = metadata === null || metadata === void 0 ? void 0 : metadata.value;
                    var label = metadata === null || metadata === void 0 ? void 0 : metadata.label;
                    if (groupId && value && label) {
                        var bar = (_a = chartComputedData.bars) === null || _a === void 0 ? void 0 : _a.find(function (bar) { var _a, _b, _c; return ((_a = bar === null || bar === void 0 ? void 0 : bar.data) === null || _a === void 0 ? void 0 : _a.id) === groupId && ((_b = bar === null || bar === void 0 ? void 0 : bar.data) === null || _b === void 0 ? void 0 : _b.value) === value && ((_c = bar === null || bar === void 0 ? void 0 : bar.data) === null || _c === void 0 ? void 0 : _c.indexValue) === label; });
                        if (!bar) {
                            ghostComments_1.push(annotation);
                        }
                    }
                });
                var width = ((_c = chartComputedData === null || chartComputedData === void 0 ? void 0 : chartComputedData.bars[0]) === null || _c === void 0 ? void 0 : _c.width) || 0;
                setGhostCommentsData({ comments: ghostComments_1, width: width, type: 'bar' });
            }
            else if (chartComputedData === null || chartComputedData === void 0 ? void 0 : chartComputedData.points) {
                var ghostComments_2 = [];
                chartComments.forEach(function (annotation) {
                    var _a;
                    var metadata = annotation.metadata;
                    var groupId = metadata === null || metadata === void 0 ? void 0 : metadata.groupId;
                    var value = metadata === null || metadata === void 0 ? void 0 : metadata.value;
                    var label = metadata === null || metadata === void 0 ? void 0 : metadata.label;
                    if (groupId && value && label) {
                        var point = (_a = chartComputedData.points) === null || _a === void 0 ? void 0 : _a.find(function (point) { var _a, _b; return (point === null || point === void 0 ? void 0 : point.serieId) === groupId && ((_a = point === null || point === void 0 ? void 0 : point.data) === null || _a === void 0 ? void 0 : _a.y) === value && ((_b = point === null || point === void 0 ? void 0 : point.data) === null || _b === void 0 ? void 0 : _b.x) === label; });
                        if (!point) {
                            ghostComments_2.push(annotation);
                        }
                    }
                });
                var width = 0;
                setGhostCommentsData({ comments: ghostComments_2, width: width, type: 'line' });
            }
        }
        catch (err) {
        }
    };
    var polarToCartesian = function (centerX, centerY, radius, angleInRadians) {
        return {
            x: centerX + radius * Math.cos(angleInRadians - Math.PI / 2),
            y: centerY + radius * Math.sin(angleInRadians - Math.PI / 2)
        };
    };
    var unsubscribeDocumentPathsSubscription = function () {
        try {
            if (documentPathsSubscription) {
                documentPathsSubscription === null || documentPathsSubscription === void 0 ? void 0 : documentPathsSubscription.unsubscribe();
            }
        }
        catch (err) {
        }
    };
    var unsubscribeCommentSubscription = function () {
        try {
            if (commentSubscription) {
                commentSubscription === null || commentSubscription === void 0 ? void 0 : commentSubscription.unsubscribe();
            }
        }
        catch (err) {
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("foreignObject", null,
            React.createElement("style", null, "\n                        .nivo-chart-comment-point {\n                            opacity: 0 !important;\n                            visibility: hidden !important;\n                          }\n                          \n                          .nivo-chart-comment-tool {\n                            opacity: 0;\n                          }\n                          \n                          .nivo-chart-comment-tool:hover {\n                            opacity: 1;\n                            visibility: visible;\n                            transition: 0.3s;\n                          }\n                          \n                          .nivo-chart-comment-container {\n                            position: relative;\n                            display: flex;\n                            flex-direction: column;\n                            align-items: center;\n                            justify-content: center;\n                            width: 100%;\n                            height: 100%;\n                          }\n                          \n                          .nivo-chart-comment-container velt-comment-tool {\n                            display: flex;\n                            cursor: pointer;\n                          }\n                          \n                          .nivo-chart-container snippyly-comment-pin-portal {\n                              /* hide it */\n                              display: none;\n                          }\n                    ")),
        ((_b = chartComputedData === null || chartComputedData === void 0 ? void 0 : chartComputedData.points) === null || _b === void 0 ? void 0 : _b.length) && chartComputedData.points.map(function (point, index) {
            var _a, _b;
            var commentMetadata = {
                id: id,
                label: (_a = point === null || point === void 0 ? void 0 : point.data) === null || _a === void 0 ? void 0 : _a.x,
                groupId: point === null || point === void 0 ? void 0 : point.serieId,
                value: (_b = point === null || point === void 0 ? void 0 : point.data) === null || _b === void 0 ? void 0 : _b.y,
            };
            return (React.createElement("g", { transform: "translate(".concat(point.x, ", ").concat(point.y, ")"), key: point.id },
                React.createElement("foreignObject", { x: -12, y: -40, width: "24", height: "24" },
                    React.createElement("div", { className: 'nivo-chart-comment-container' },
                        React.createElement(VeltChartComment, { commentMetadata: commentMetadata, dialogMetadataTemplate: dialogMetadataTemplate || ['groupId', 'label', 'value'] })))));
        }),
        ((_c = chartComputedData === null || chartComputedData === void 0 ? void 0 : chartComputedData.bars) === null || _c === void 0 ? void 0 : _c.length) && chartComputedData.bars.map(function (point, index) {
            var _a, _b, _c;
            var commentMetadata = {
                id: id,
                label: (_a = point === null || point === void 0 ? void 0 : point.data) === null || _a === void 0 ? void 0 : _a.indexValue,
                groupId: (_b = point === null || point === void 0 ? void 0 : point.data) === null || _b === void 0 ? void 0 : _b.id,
                value: (_c = point === null || point === void 0 ? void 0 : point.data) === null || _c === void 0 ? void 0 : _c.value,
            };
            return (React.createElement("g", { transform: "translate(".concat(point.x + point.width, ", ").concat(point.y, ")"), key: point.key },
                React.createElement("foreignObject", { x: 0, y: -8, width: "24", height: "24" },
                    React.createElement("div", { className: 'nivo-chart-comment-container' },
                        React.createElement(VeltChartComment, { commentMetadata: commentMetadata, dialogMetadataTemplate: dialogMetadataTemplate || ['groupId', 'label', 'value'] })))));
        }),
        ((_d = chartComputedData === null || chartComputedData === void 0 ? void 0 : chartComputedData.dataWithArc) === null || _d === void 0 ? void 0 : _d.length) && chartComputedData.dataWithArc.map(function (arcData, index) {
            var midAngle = (arcData.arc.startAngle + arcData.arc.endAngle) / 2;
            var radiusOffset = 20; // Extend beyond the outer radius for visibility
            var position = polarToCartesian(chartComputedData.centerX, chartComputedData.centerY, arcData.arc.outerRadius + radiusOffset, midAngle);
            var commentMetadata = {
                id: id,
                label: arcData === null || arcData === void 0 ? void 0 : arcData.label,
                value: arcData === null || arcData === void 0 ? void 0 : arcData.value,
            };
            return (React.createElement("g", { transform: "translate(".concat(position.x, ", ").concat(position.y, ")"), key: arcData.id },
                React.createElement("foreignObject", { width: "100", height: "50", x: "-50", y: "-25", style: { overflow: 'visible' } },
                    React.createElement("div", { className: 'nivo-chart-comment-container' },
                        React.createElement(VeltChartComment, { commentMetadata: commentMetadata, dialogMetadataTemplate: dialogMetadataTemplate || ['label', 'value'] })))));
        }),
        ((_e = ghostCommentsData === null || ghostCommentsData === void 0 ? void 0 : ghostCommentsData.comments) === null || _e === void 0 ? void 0 : _e.length) && ((_f = ghostCommentsData === null || ghostCommentsData === void 0 ? void 0 : ghostCommentsData.comments) === null || _f === void 0 ? void 0 : _f.map(function (annotation) {
            var metadata = annotation.metadata;
            var groupId = metadata === null || metadata === void 0 ? void 0 : metadata.groupId;
            var value = metadata === null || metadata === void 0 ? void 0 : metadata.value;
            var label = metadata === null || metadata === void 0 ? void 0 : metadata.label;
            var x = (chartComputedData === null || chartComputedData === void 0 ? void 0 : chartComputedData.xScale) ? chartComputedData.xScale(label) : 0;
            var y = (chartComputedData === null || chartComputedData === void 0 ? void 0 : chartComputedData.yScale) ? chartComputedData.yScale(value) : 0;
            var point = { x: x, y: y, width: (ghostCommentsData === null || ghostCommentsData === void 0 ? void 0 : ghostCommentsData.width) || 0, key: annotation.annotationId };
            var commentMetadata = {
                id: id,
                label: label,
                groupId: groupId,
                value: value,
            };
            switch (ghostCommentsData === null || ghostCommentsData === void 0 ? void 0 : ghostCommentsData.type) {
                case 'bar':
                    return (React.createElement("g", { transform: "translate(".concat(point.x + point.width, ", ").concat(point.y, ")"), key: point.key },
                        React.createElement("foreignObject", { x: 0, y: -8, width: "24", height: "24" },
                            React.createElement("div", { className: 'nivo-chart-comment-container' },
                                React.createElement(VeltChartComment, { ghostComment: true, commentMetadata: commentMetadata, dialogMetadataTemplate: dialogMetadataTemplate || ['groupId', 'label', 'value'] })))));
                case 'line':
                    return (React.createElement("g", { transform: "translate(".concat(point.x + point.width, ", ").concat(point.y, ")"), key: point.key },
                        React.createElement("foreignObject", { x: -12, y: -48, width: "24", height: "24" },
                            React.createElement("div", { className: 'nivo-chart-comment-container' },
                                React.createElement(VeltChartComment, { ghostComment: true, commentMetadata: commentMetadata, dialogMetadataTemplate: dialogMetadataTemplate || ['groupId', 'label', 'value'] })))));
                default:
                    return null;
            }
        }))));
};

var VeltHighChartComments = function (_a) {
    var chartComputedData = _a.chartComputedData, id = _a.id, dialogMetadataTemplate = _a.dialogMetadataTemplate, Highcharts = _a.Highcharts;
    var _b = useState([]), points = _b[0], setPoints = _b[1];
    var _c = useState([]), ghostPoints = _c[0], setGhostPoints = _c[1];
    var chartRef = useRef(chartComputedData);
    var commentsRef = useRef([]);
    var client = useVeltClient().client;
    var _d = React.useState(null), documentPathsSubscription = _d[0], setDocumentPathsSubscription = _d[1];
    var _e = useState(null), commentSubscription = _e[0], setCommentSubscription = _e[1];
    // Unsubscribe from the subscriptions when the component is unmounted
    useEffect(function () {
        return function () {
            unsubscribeDocumentPathsSubscription();
            unsubscribeCommentSubscription();
        };
    }, []);
    useEffect(function () {
        if (client) {
            getCommentAnnotations();
        }
    }, [client]);
    var getCommentAnnotations = function () {
        var _a;
        try {
            unsubscribeDocumentPathsSubscription();
            unsubscribeCommentSubscription();
            if (client) {
                var subscription = (_a = client === null || client === void 0 ? void 0 : client.docService) === null || _a === void 0 ? void 0 : _a.getDocumentPaths$().subscribe(function (paths) {
                    var _a;
                    if (paths === null || paths === void 0 ? void 0 : paths.clientDocumentId) {
                        unsubscribeCommentSubscription();
                        var commentElement = client.getCommentElement();
                        var subscription_1 = (_a = commentElement === null || commentElement === void 0 ? void 0 : commentElement.getAllCommentAnnotations(paths === null || paths === void 0 ? void 0 : paths.clientDocumentId)) === null || _a === void 0 ? void 0 : _a.subscribe(function (comments) {
                            commentsRef.current = comments;
                            filterGhostComments(comments);
                        });
                        setCommentSubscription(subscription_1);
                    }
                });
                setDocumentPathsSubscription(subscription);
            }
        }
        catch (err) {
        }
    };
    var filterGhostComments = function (comments) {
        var _a;
        try {
            var chartComments = (_a = comments === null || comments === void 0 ? void 0 : comments.filter(function (annotation) { return annotation.commentType === 'chart'; })) === null || _a === void 0 ? void 0 : _a.filter(function (annotation) { var _a; return ((_a = annotation === null || annotation === void 0 ? void 0 : annotation.metadata) === null || _a === void 0 ? void 0 : _a.id) === id; });
            var ghostPoints_1 = [];
            chartComments.forEach(function (annotation) {
                var metadata = annotation.metadata;
                var groupId = metadata === null || metadata === void 0 ? void 0 : metadata.groupId;
                var value = metadata === null || metadata === void 0 ? void 0 : metadata.value;
                var label = metadata === null || metadata === void 0 ? void 0 : metadata.label;
                if (groupId && value && label) {
                    var series = chartRef.current.chart.series.find(function (series) { return series.name === groupId; });
                    if (series === null || series === void 0 ? void 0 : series.visible) {
                        switch (series.type) {
                            case 'line':
                                var linePoint = series.points.find(function (point) { return point.y === value && point.x === label; });
                                if (!linePoint) {
                                    var x = series.xAxis.toPixels(label, true);
                                    var y = series.yAxis.toPixels(value, true);
                                    ghostPoints_1.push({
                                        x: x,
                                        y: y,
                                        seriesName: groupId,
                                        yValue: value,
                                        transform: 'translate(-50%, -150%)',
                                        id: "".concat(groupId, "-").concat(label, "-").concat(value),
                                        metadata: {
                                            id: id,
                                            groupId: groupId,
                                            label: label,
                                            value: value,
                                        },
                                    });
                                }
                                break;
                            case 'bar':
                            case 'column':
                                var barPoint = series.points.find(function (point) { return point.y === value && point.category === label; });
                                if (!barPoint) {
                                    var categoryIndex = series.xAxis.categories.indexOf(label);
                                    var x = series.xAxis.toPixels(categoryIndex, true);
                                    var y = series.yAxis.toPixels(value, true);
                                    // const width = series.xAxis.toPixels(categoryIndex + 1, true) - x;
                                    ghostPoints_1.push({
                                        x: x,
                                        y: y,
                                        seriesName: groupId,
                                        yValue: value,
                                        id: "".concat(groupId, "-").concat(label, "-").concat(value),
                                        // width: width,
                                        transform: 'translate(-50%, -100%)',
                                        metadata: {
                                            id: id,
                                            groupId: groupId,
                                            label: label,
                                            value: value,
                                        },
                                    });
                                }
                        }
                    }
                }
            });
            setGhostPoints(ghostPoints_1);
        }
        catch (err) {
        }
    };
    useEffect(function () {
        // Attach the redraw event listener when the chart updates
        if (chartRef.current && chartRef.current.chart) {
            var currentChart_1 = chartRef.current.chart;
            window.chart = currentChart_1;
            // Define the callback to execute on chart redraw
            var onRedraw_1 = function () {
                calculatePoints();
                filterGhostComments(commentsRef.current);
            };
            if (Highcharts) {
                // Attach the event listener
                Highcharts.addEvent(currentChart_1, 'redraw', onRedraw_1);
            }
            // Perform the initial calculation
            calculatePoints();
            // Clean up the event listener when the component unmounts or chart changes
            return function () {
                if (Highcharts) {
                    Highcharts.removeEvent(currentChart_1, 'redraw', onRedraw_1);
                }
            };
        }
    }, [chartComputedData]);
    var calculatePoints = function (from) {
        var _a, _b;
        if (!((_b = (_a = chartRef.current) === null || _a === void 0 ? void 0 : _a.chart) === null || _b === void 0 ? void 0 : _b.series)) {
            return;
        }
        // Create an array of points from all series
        var newPoints = chartRef.current.chart.series.filter(function (series) { return series.visible; }).reduce(function (acc, series) {
            var seriesPoints = [];
            switch (series.type) {
                case 'line':
                    seriesPoints = series.points.map(function (point) { return ({
                        x: point.plotX,
                        y: point.plotY,
                        seriesName: series.name,
                        yValue: point.y,
                        transform: 'translate(-50%, -150%)',
                        id: "".concat(series.name, "-").concat(point.x, "-").concat(point.y),
                        metadata: {
                            id: id,
                            groupId: series.name,
                            label: point.x,
                            value: point.y,
                        },
                    }); });
                    break;
                case 'bar':
                case 'column':
                    seriesPoints = series.points.map(function (point) {
                        var _a, _b, _c, _d, _e, _f, _g;
                        var x = (_a = point.shapeArgs) === null || _a === void 0 ? void 0 : _a.x;
                        var y = (_b = point.shapeArgs) === null || _b === void 0 ? void 0 : _b.y;
                        var transform = 'translate(-50%, -100%)';
                        var width = (_c = point.shapeArgs) === null || _c === void 0 ? void 0 : _c.width;
                        (_d = point.shapeArgs) === null || _d === void 0 ? void 0 : _d.height;
                        if (series.type === 'column') {
                            // Center horizontally for columns
                            x += point.shapeArgs.width / 2;
                        }
                        else if (series.type === 'bar') {
                            // Center vertically for bars
                            // y += point.shapeArgs!.height / 2;
                            x = (_e = point.shapeArgs) === null || _e === void 0 ? void 0 : _e.brBoxHeight;
                            transform = null;
                            (_f = point.shapeArgs) === null || _f === void 0 ? void 0 : _f.width;
                            width = null;
                            // y = (point.shapeArgs?.x! / 2) + (point.shapeArgs?.width! / 2);
                            // x = point.plotX! - (point?.shapeArgs?.width! / 2);
                            y = (_g = point.shapeArgs) === null || _g === void 0 ? void 0 : _g.x;
                        }
                        return {
                            x: x,
                            y: y,
                            seriesName: series.name,
                            yValue: point.y,
                            id: "".concat(series.name, "-").concat(point.x, "-").concat(point.y),
                            width: width,
                            // height: height,
                            transform: transform,
                            metadata: {
                                id: id,
                                groupId: series.name,
                                label: point.category,
                                value: point.y,
                            },
                        };
                    });
                    break;
            }
            return __spreadArray(__spreadArray([], acc, true), seriesPoints, true);
        }, []);
        setPoints(newPoints);
    };
    var unsubscribeDocumentPathsSubscription = function () {
        try {
            if (documentPathsSubscription) {
                documentPathsSubscription === null || documentPathsSubscription === void 0 ? void 0 : documentPathsSubscription.unsubscribe();
            }
        }
        catch (err) {
        }
    };
    var unsubscribeCommentSubscription = function () {
        try {
            if (commentSubscription) {
                commentSubscription === null || commentSubscription === void 0 ? void 0 : commentSubscription.unsubscribe();
            }
        }
        catch (err) {
        }
    };
    return (React.createElement("div", { className: 'velt-chart-comments-container', style: {
            zIndex: 100000,
            position: 'absolute',
            top: 0,
            left: 0,
        } },
        React.createElement("style", null, "\n                        .velt-chart-comments-container .point-container {\n                            opacity: 0 !important;\n                            visibility: hidden !important;\n                        }\n                    "),
        points.map(function (point, index) { return (React.createElement("div", { key: index, style: {
                position: 'absolute',
                left: "".concat(chartRef.current.chart.plotLeft + point.x, "px"),
                top: "".concat(chartRef.current.chart.plotTop + point.y, "px"),
                transform: point.transform,
                padding: '2px 5px',
                color: '#fff',
                borderRadius: '3px',
                fontSize: '10px',
                width: "".concat(point.width, "px"),
                height: "".concat(point.height, "px"),
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                userSelect: 'none',
                boxSizing: 'border-box',
            } },
            React.createElement(VeltChartComment, { commentMetadata: point.metadata, dialogMetadataTemplate: dialogMetadataTemplate || point.dialogMetadataTemplate || ['groupId', 'label', 'value'] }))); }),
        ghostPoints.map(function (point, index) { return (React.createElement("div", { id: point.id, key: index, style: {
                position: 'absolute',
                left: "".concat(chartRef.current.chart.plotLeft + point.x, "px"),
                top: "".concat(chartRef.current.chart.plotTop + point.y, "px"),
                transform: point.transform,
                padding: '2px 5px',
                color: '#fff',
                borderRadius: '3px',
                fontSize: '10px',
                width: "".concat(point.width, "px"),
                height: "".concat(point.height, "px"),
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                userSelect: 'none',
                boxSizing: 'border-box',
            } },
            React.createElement(VeltChartComment, { ghostComment: true, commentMetadata: point.metadata, dialogMetadataTemplate: dialogMetadataTemplate || point.dialogMetadataTemplate || ['groupId', 'label', 'value'] }))); })));
};

var VeltAutocomplete = function (props) {
    var hotkey = props.hotkey, listData = props.listData;
    return (React.createElement("velt-autocomplete", { hotkey: hotkey, "list-data": (typeof listData === 'object') ? JSON.stringify(listData) : undefined }));
};

var VeltInlineCommentsSection = function (props) {
    var config = props.config, children = props.children, darkMode = props.darkMode, variant = props.variant, shadowDom = props.shadowDom, dialogVariant = props.dialogVariant, targetInlineCommentElementId = props.targetInlineCommentElementId;
    return (React.createElement("velt-inline-comments-section", { "target-inline-comment-element-id": targetInlineCommentElementId, config: JSON.stringify(config), variant: variant, "dialog-variant": dialogVariant, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined }, children));
};

var VeltCommentPin = function (props) {
    var children = props.children, annotationId = props.annotationId;
    return (React.createElement("velt-comment-pin", { "annotation-id": annotationId }, children));
};

var VeltCanvasComment = function (props) {
    var children = props.children, canvasId = props.canvasId, position = props.position;
    return (React.createElement("velt-canvas-comment", { "canvas-id": canvasId, position: JSON.stringify(position) }, children));
};

var VeltWireframe = function (props) {
    var children = props.children;
    return (React.createElement("velt-wireframe", { style: { display: 'none' } }, children));
};

var VeltCommentDialogAllComment = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-all-comment-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogApprove = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-approve-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogAssignMenu = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-assign-menu-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogAssigneeBannerResolveButton = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-assignee-banner-resolve-button-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogAssigneeBannerUserAvatar = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-assignee-banner-user-avatar-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogAssigneeBannerUserName = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-assignee-banner-user-name-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogAssigneeBanner = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-assignee-banner-wireframe", __assign({}, remainingProp), children));
};
VeltCommentDialogAssigneeBanner.ResolveButton = VeltCommentDialogAssigneeBannerResolveButton;
VeltCommentDialogAssigneeBanner.UserAvatar = VeltCommentDialogAssigneeBannerUserAvatar;
VeltCommentDialogAssigneeBanner.UserName = VeltCommentDialogAssigneeBannerUserName;

var VeltCommentDialogBody = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-body-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogCommentCategory = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-comment-category-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogCommentIndex = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-comment-index-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogCommentSuggestionStatus = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-comment-suggestion-status-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogComposerActionButton = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-composer-action-button-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentDialogComposerAssignUser = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-composer-assign-user-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogComposerAttachmentsInvalidItemPreview = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-composer-attachments-invalid-item-preview-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogComposerAttachmentsInvalidItemMessage = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-composer-attachments-invalid-item-message-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogComposerAttachmentsInvalidItemDelete = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-composer-attachments-invalid-item-delete-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogComposerAttachmentsInvalidItem = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-composer-attachments-invalid-item-wireframe", __assign({}, remainingProp), children));
};
VeltCommentDialogComposerAttachmentsInvalidItem.Preview = VeltCommentDialogComposerAttachmentsInvalidItemPreview;
VeltCommentDialogComposerAttachmentsInvalidItem.Message = VeltCommentDialogComposerAttachmentsInvalidItemMessage;
VeltCommentDialogComposerAttachmentsInvalidItem.Delete = VeltCommentDialogComposerAttachmentsInvalidItemDelete;

var VeltCommentDialogComposerAttachmentsInvalid = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-composer-attachments-invalid-wireframe", __assign({}, remainingProp), children));
};
VeltCommentDialogComposerAttachmentsInvalid.Item = VeltCommentDialogComposerAttachmentsInvalidItem;

var VeltCommentDialogComposerAttachmentsImagePreview = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-composer-attachments-image-preview-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogComposerAttachmentsImageDelete = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-composer-attachments-image-delete-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogComposerAttachmentsImageLoading = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-composer-attachments-image-loading-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogComposerAttachmentsImage = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-composer-attachments-image-wireframe", __assign({}, remainingProp), children));
};
VeltCommentDialogComposerAttachmentsImage.Preview = VeltCommentDialogComposerAttachmentsImagePreview;
VeltCommentDialogComposerAttachmentsImage.Loading = VeltCommentDialogComposerAttachmentsImageLoading;
VeltCommentDialogComposerAttachmentsImage.Delete = VeltCommentDialogComposerAttachmentsImageDelete;

var VeltCommentDialogComposerAttachmentsOtherDelete = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-composer-attachments-other-delete-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogComposerAttachmentsOtherIcon = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-composer-attachments-other-icon-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogComposerAttachmentsOtherLoading = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-composer-attachments-other-loading-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogComposerAttachmentsOtherName = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-composer-attachments-other-name-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogComposerAttachmentsOtherSize = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-composer-attachments-other-size-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogComposerAttachmentsOther = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-composer-attachments-other-wireframe", __assign({}, remainingProp), children));
};
VeltCommentDialogComposerAttachmentsOther.Delete = VeltCommentDialogComposerAttachmentsOtherDelete;
VeltCommentDialogComposerAttachmentsOther.Loading = VeltCommentDialogComposerAttachmentsOtherLoading;
VeltCommentDialogComposerAttachmentsOther.Icon = VeltCommentDialogComposerAttachmentsOtherIcon;
VeltCommentDialogComposerAttachmentsOther.Name = VeltCommentDialogComposerAttachmentsOtherName;
VeltCommentDialogComposerAttachmentsOther.Size = VeltCommentDialogComposerAttachmentsOtherSize;

var VeltCommentDialogComposerAttachmentsSelected = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-composer-attachments-selected-wireframe", __assign({}, remainingProp), children));
};
VeltCommentDialogComposerAttachmentsSelected.Image = VeltCommentDialogComposerAttachmentsImage;
VeltCommentDialogComposerAttachmentsSelected.Other = VeltCommentDialogComposerAttachmentsOther;

var VeltCommentDialogComposerAttachments = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-composer-attachments-wireframe", __assign({}, remainingProp), children));
};
VeltCommentDialogComposerAttachments.Invalid = VeltCommentDialogComposerAttachmentsInvalid;
VeltCommentDialogComposerAttachments.Selected = VeltCommentDialogComposerAttachmentsSelected;

var VeltCommentDialogComposerInput = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-composer-input-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogComposerRecordings = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-composer-recordings-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogComposerPrivateBadge = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-composer-private-badge-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogComposerAvatar = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-composer-avatar-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogComposer = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-composer-wireframe", __assign({}, remainingProp), children));
};
VeltCommentDialogComposer.ActionButton = VeltCommentDialogComposerActionButton;
VeltCommentDialogComposer.AssignUser = VeltCommentDialogComposerAssignUser;
VeltCommentDialogComposer.Attachments = VeltCommentDialogComposerAttachments;
VeltCommentDialogComposer.Input = VeltCommentDialogComposerInput;
VeltCommentDialogComposer.Recordings = VeltCommentDialogComposerRecordings;
VeltCommentDialogComposer.PrivateBadge = VeltCommentDialogComposerPrivateBadge;
VeltCommentDialogComposer.Avatar = VeltCommentDialogComposerAvatar;

var VeltCommentDialogCopyLink = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-copy-link-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogGhostBanner = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-ghost-banner-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogHeader = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-header-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogMoreReply = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-more-reply-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogOptionsDropdownContentAssignWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-options-dropdown-content-assign-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogOptionsDropdownContentDeleteCommentWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-options-dropdown-content-delete-comment-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentDialogOptionsDropdownContentDeleteThreadWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-options-dropdown-content-delete-thread-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentDialogOptionsDropdownContentDeleteWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-options-dropdown-content-delete-wireframe", __assign({}, remainingProp), children));
};
VeltCommentDialogOptionsDropdownContentDeleteWireframe.Comment = VeltCommentDialogOptionsDropdownContentDeleteCommentWireframe;
VeltCommentDialogOptionsDropdownContentDeleteWireframe.Thread = VeltCommentDialogOptionsDropdownContentDeleteThreadWireframe;

var VeltCommentDialogOptionsDropdownContentEditWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-options-dropdown-content-edit-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogOptionsDropdownContentMakePrivateDisableWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-options-dropdown-content-make-private-disable-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentDialogOptionsDropdownContentMakePrivateEnableWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-options-dropdown-content-make-private-enable-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentDialogOptionsDropdownContentMakePrivateWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-options-dropdown-content-make-private-wireframe", __assign({}, remainingProp), children));
};
VeltCommentDialogOptionsDropdownContentMakePrivateWireframe.Enable = VeltCommentDialogOptionsDropdownContentMakePrivateEnableWireframe;
VeltCommentDialogOptionsDropdownContentMakePrivateWireframe.Disable = VeltCommentDialogOptionsDropdownContentMakePrivateDisableWireframe;

var VeltCommentDialogOptionsDropdownContentWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-options-dropdown-content-wireframe", __assign({}, remainingProp), children));
};
VeltCommentDialogOptionsDropdownContentWireframe.Assign = VeltCommentDialogOptionsDropdownContentAssignWireframe;
VeltCommentDialogOptionsDropdownContentWireframe.MakePrivate = VeltCommentDialogOptionsDropdownContentMakePrivateWireframe;
VeltCommentDialogOptionsDropdownContentWireframe.Edit = VeltCommentDialogOptionsDropdownContentEditWireframe;
VeltCommentDialogOptionsDropdownContentWireframe.Delete = VeltCommentDialogOptionsDropdownContentDeleteWireframe;

var VeltCommentDialogOptionsDropdownTriggerWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-options-dropdown-trigger-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogOptions = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-options-wireframe", __assign({}, remainingProp), children));
};
VeltCommentDialogOptions.Content = VeltCommentDialogOptionsDropdownContentWireframe;
VeltCommentDialogOptions.Trigger = VeltCommentDialogOptionsDropdownTriggerWireframe;

var VeltCommentDialogPriorityDropdownContentItemIconWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-priority-dropdown-content-item-icon-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentDialogPriorityDropdownContentItemNameWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-priority-dropdown-content-item-name-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentDialogPriorityDropdownContentItemTickWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-priority-dropdown-content-item-tick-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentDialogPriorityDropdownContentItemWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-priority-dropdown-content-item-wireframe", __assign({}, remainingProp), children));
};
VeltCommentDialogPriorityDropdownContentItemWireframe.Icon = VeltCommentDialogPriorityDropdownContentItemIconWireframe;
VeltCommentDialogPriorityDropdownContentItemWireframe.Name = VeltCommentDialogPriorityDropdownContentItemNameWireframe;
VeltCommentDialogPriorityDropdownContentItemWireframe.Tick = VeltCommentDialogPriorityDropdownContentItemTickWireframe;

var VeltCommentDialogPriorityDropdownContentWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-priority-dropdown-content-wireframe", __assign({}, remainingProp), children));
};
VeltCommentDialogPriorityDropdownContentWireframe.Item = VeltCommentDialogPriorityDropdownContentItemWireframe;

var VeltCommentDialogPriorityDropdownTriggerArrowWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-priority-dropdown-trigger-arrow-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentDialogPriorityDropdownTriggerIconWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-priority-dropdown-trigger-icon-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentDialogPriorityDropdownTriggerNameWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-priority-dropdown-trigger-name-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentDialogPriorityDropdownTriggerWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-priority-dropdown-trigger-wireframe", __assign({}, remainingProp), children));
};
VeltCommentDialogPriorityDropdownTriggerWireframe.Arrow = VeltCommentDialogPriorityDropdownTriggerArrowWireframe;
VeltCommentDialogPriorityDropdownTriggerWireframe.Name = VeltCommentDialogPriorityDropdownTriggerNameWireframe;
VeltCommentDialogPriorityDropdownTriggerWireframe.Icon = VeltCommentDialogPriorityDropdownTriggerIconWireframe;

var VeltCommentDialogPriority = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-priority-wireframe", __assign({}, remainingProp), children));
};
VeltCommentDialogPriority.Content = VeltCommentDialogPriorityDropdownContentWireframe;
VeltCommentDialogPriority.Trigger = VeltCommentDialogPriorityDropdownTriggerWireframe;

var VeltCommentDialogPrivateBanner = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-private-banner-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogResolveButton = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-resolve-button-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogSignIn = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-sign-in-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogStatusDropdownContentItemIconWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-status-dropdown-content-item-icon-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentDialogStatusDropdownContentItemNameWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-status-dropdown-content-item-name-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentDialogStatusDropdownContentItemWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-status-dropdown-content-item-wireframe", __assign({}, remainingProp), children));
};
VeltCommentDialogStatusDropdownContentItemWireframe.Icon = VeltCommentDialogStatusDropdownContentItemIconWireframe;
VeltCommentDialogStatusDropdownContentItemWireframe.Name = VeltCommentDialogStatusDropdownContentItemNameWireframe;

var VeltCommentDialogStatusDropdownContentWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-status-dropdown-content-wireframe", __assign({}, remainingProp), children));
};
VeltCommentDialogStatusDropdownContentWireframe.Item = VeltCommentDialogStatusDropdownContentItemWireframe;

var VeltCommentDialogStatusDropdownTriggerArrowWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-status-dropdown-trigger-arrow-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentDialogStatusDropdownTriggerIconWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-status-dropdown-trigger-icon-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentDialogStatusDropdownTriggerNameWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-status-dropdown-trigger-name-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentDialogStatusDropdownTriggerWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-status-dropdown-trigger-wireframe", __assign({}, remainingProp), children));
};
VeltCommentDialogStatusDropdownTriggerWireframe.Arrow = VeltCommentDialogStatusDropdownTriggerArrowWireframe;
VeltCommentDialogStatusDropdownTriggerWireframe.Name = VeltCommentDialogStatusDropdownTriggerNameWireframe;
VeltCommentDialogStatusDropdownTriggerWireframe.Icon = VeltCommentDialogStatusDropdownTriggerIconWireframe;

var VeltCommentDialogStatus = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-status-wireframe", __assign({}, remainingProp), children));
};
VeltCommentDialogStatus.Content = VeltCommentDialogStatusDropdownContentWireframe;
VeltCommentDialogStatus.Trigger = VeltCommentDialogStatusDropdownTriggerWireframe;

var VeltCommentDialogSuggestionActionAccept = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-suggestion-action-accept-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogSuggestionActionReject = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-suggestion-action-reject-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogSuggestionAction = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-suggestion-action-wireframe", __assign({}, remainingProp), children));
};
VeltCommentDialogSuggestionAction.Accept = VeltCommentDialogSuggestionActionAccept;
VeltCommentDialogSuggestionAction.Reject = VeltCommentDialogSuggestionActionReject;

var VeltCommentDialogThreadCardAttachmentsImagePreview = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-thread-card-attachments-image-preview-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogThreadCardAttachmentsImageDelete = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-thread-card-attachments-image-delete-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogThreadCardAttachmentsImageDownload = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-thread-card-attachments-image-download-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogThreadCardAttachmentsImage = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-thread-card-attachments-image-wireframe", __assign({}, remainingProp), children));
};
VeltCommentDialogThreadCardAttachmentsImage.Preview = VeltCommentDialogThreadCardAttachmentsImagePreview;
VeltCommentDialogThreadCardAttachmentsImage.Download = VeltCommentDialogThreadCardAttachmentsImageDownload;
VeltCommentDialogThreadCardAttachmentsImage.Delete = VeltCommentDialogThreadCardAttachmentsImageDelete;

var VeltCommentDialogThreadCardAttachmentsOtherDelete = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-thread-card-attachments-other-delete-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogThreadCardAttachmentsOtherDownload = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-thread-card-attachments-other-download-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogThreadCardAttachmentsOtherIcon = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-thread-card-attachments-other-icon-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogThreadCardAttachmentsOtherName = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-thread-card-attachments-other-name-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogThreadCardAttachmentsOtherSize = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-thread-card-attachments-other-size-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogThreadCardAttachmentsOther = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-thread-card-attachments-other-wireframe", __assign({}, remainingProp), children));
};
VeltCommentDialogThreadCardAttachmentsOther.Icon = VeltCommentDialogThreadCardAttachmentsOtherIcon;
VeltCommentDialogThreadCardAttachmentsOther.Name = VeltCommentDialogThreadCardAttachmentsOtherName;
VeltCommentDialogThreadCardAttachmentsOther.Size = VeltCommentDialogThreadCardAttachmentsOtherSize;
VeltCommentDialogThreadCardAttachmentsOther.Download = VeltCommentDialogThreadCardAttachmentsOtherDownload;
VeltCommentDialogThreadCardAttachmentsOther.Delete = VeltCommentDialogThreadCardAttachmentsOtherDelete;

var VeltCommentDialogThreadCardAttachments = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-thread-card-attachments-wireframe", __assign({}, remainingProp), children));
};
VeltCommentDialogThreadCardAttachments.Other = VeltCommentDialogThreadCardAttachmentsOther;
VeltCommentDialogThreadCardAttachments.Image = VeltCommentDialogThreadCardAttachmentsImage;

var VeltCommentDialogThreadCardAvatar = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-thread-card-avatar-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogThreadCardDeviceType = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-thread-card-device-type-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogThreadCardMessage = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-thread-card-message-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogThreadCardName = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-thread-card-name-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogThreadCardOptions = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-thread-card-options-wireframe", __assign({}, remainingProp), children));
};
VeltCommentDialogThreadCardOptions.Content = VeltCommentDialogOptionsDropdownContentWireframe;
VeltCommentDialogThreadCardOptions.Trigger = VeltCommentDialogOptionsDropdownTriggerWireframe;

var VeltCommentDialogThreadCardReactionTool = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-thread-card-reaction-tool-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogThreadCardReactions = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-thread-card-reactions-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogThreadCardRecordings = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-thread-card-recordings-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogThreadCardTime = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-thread-card-time-wireframe", __assign({}, remainingProp), children));
};

// Main Thread Card component
var VeltCommentDialogThreadCard = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-thread-card-wireframe", __assign({}, remainingProp), children));
};
// Attach the Sub component as a static property of the main Thread Card component
VeltCommentDialogThreadCard.Avatar = VeltCommentDialogThreadCardAvatar;
VeltCommentDialogThreadCard.DeviceType = VeltCommentDialogThreadCardDeviceType;
VeltCommentDialogThreadCard.Attachments = VeltCommentDialogThreadCardAttachments;
VeltCommentDialogThreadCard.Message = VeltCommentDialogThreadCardMessage;
VeltCommentDialogThreadCard.Name = VeltCommentDialogThreadCardName;
VeltCommentDialogThreadCard.Options = VeltCommentDialogThreadCardOptions;
VeltCommentDialogThreadCard.Reactions = VeltCommentDialogThreadCardReactions;
VeltCommentDialogThreadCard.ReactionTool = VeltCommentDialogThreadCardReactionTool;
VeltCommentDialogThreadCard.Recordings = VeltCommentDialogThreadCardRecordings;
VeltCommentDialogThreadCard.Time = VeltCommentDialogThreadCardTime;

var VeltCommentDialogThreads = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-threads-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogToggleReply = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-toggle-reply-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogUpgrade = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-upgrade-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentDialogWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-wireframe", __assign({}, remainingProp), children));
};
VeltCommentDialogWireframe.AllComment = VeltCommentDialogAllComment;
VeltCommentDialogWireframe.Approve = VeltCommentDialogApprove;
VeltCommentDialogWireframe.AssigneeBanner = VeltCommentDialogAssigneeBanner;
VeltCommentDialogWireframe.AssignMenu = VeltCommentDialogAssignMenu;
VeltCommentDialogWireframe.Body = VeltCommentDialogBody;
VeltCommentDialogWireframe.CommentCategory = VeltCommentDialogCommentCategory;
VeltCommentDialogWireframe.CommentIndex = VeltCommentDialogCommentIndex;
VeltCommentDialogWireframe.CommentSuggestionStatus = VeltCommentDialogCommentSuggestionStatus;
VeltCommentDialogWireframe.Composer = VeltCommentDialogComposer;
VeltCommentDialogWireframe.CopyLink = VeltCommentDialogCopyLink;
VeltCommentDialogWireframe.GhostBanner = VeltCommentDialogGhostBanner;
VeltCommentDialogWireframe.Header = VeltCommentDialogHeader;
VeltCommentDialogWireframe.MoreReply = VeltCommentDialogMoreReply;
VeltCommentDialogWireframe.Options = VeltCommentDialogOptions;
VeltCommentDialogWireframe.Priority = VeltCommentDialogPriority;
VeltCommentDialogWireframe.PrivateBanner = VeltCommentDialogPrivateBanner;
VeltCommentDialogWireframe.ResolveButton = VeltCommentDialogResolveButton;
VeltCommentDialogWireframe.SignIn = VeltCommentDialogSignIn;
VeltCommentDialogWireframe.Status = VeltCommentDialogStatus;
VeltCommentDialogWireframe.SuggestionAction = VeltCommentDialogSuggestionAction;
VeltCommentDialogWireframe.ThreadCard = VeltCommentDialogThreadCard;
VeltCommentDialogWireframe.Threads = VeltCommentDialogThreads;
VeltCommentDialogWireframe.ToggleReply = VeltCommentDialogToggleReply;
VeltCommentDialogWireframe.Upgrade = VeltCommentDialogUpgrade;

var VeltCommentsSidebarCloseButton = function (props) {
    props.children; var remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-close-button-wireframe", __assign({}, remainingProps)));
};

var VeltCommentsSidebarEmptyPlaceholder = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-empty-placeholder-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentsSidebarFilterItemCheckboxChecked = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-filter-item-checkbox-checked-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentsSidebarFilterItemCheckboxUnchecked = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-filter-item-checkbox-unchecked-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentsSidebarFilterItemCheckbox = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-filter-item-checkbox-wireframe", __assign({}, remainingProps), children));
};
VeltCommentsSidebarFilterItemCheckbox.Checked = VeltCommentsSidebarFilterItemCheckboxChecked;
VeltCommentsSidebarFilterItemCheckbox.Unchecked = VeltCommentsSidebarFilterItemCheckboxUnchecked;

var VeltCommentsSidebarFilterItemCount = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-filter-item-count-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentsSidebarFilterItemName = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-filter-item-name-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentsSidebarFilterItem = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-filter-item-wireframe", __assign({}, remainingProps), children));
};
VeltCommentsSidebarFilterItem.Checkbox = VeltCommentsSidebarFilterItemCheckbox;
VeltCommentsSidebarFilterItem.Count = VeltCommentsSidebarFilterItemCount;
VeltCommentsSidebarFilterItem.Name = VeltCommentsSidebarFilterItemName;

var VeltCommentsSidebarFilterName = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-filter-name-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentsSidebarFilterCategory = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-filter-category-wireframe", __assign({}, remainingProps), children));
};
VeltCommentsSidebarFilterCategory.Name = VeltCommentsSidebarFilterName;
VeltCommentsSidebarFilterCategory.Item = VeltCommentsSidebarFilterItem;

var VeltCommentsSidebarFilterCloseButton = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-filter-close-button-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentsSidebarFilterCommentType = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-filter-comment-type-wireframe", __assign({}, remainingProps), children));
};
VeltCommentsSidebarFilterCommentType.Name = VeltCommentsSidebarFilterName;
VeltCommentsSidebarFilterCommentType.Item = VeltCommentsSidebarFilterItem;

var VeltCommentsSidebarFilterDoneButton = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-filter-done-button-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentsSidebarFilterGroupBy = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-filter-group-by-wireframe", __assign({}, remainingProps), children));
};
VeltCommentsSidebarFilterGroupBy.Name = VeltCommentsSidebarFilterName;
VeltCommentsSidebarFilterGroupBy.Item = VeltCommentsSidebarFilterItem;

var VeltCommentsSidebarFilterViewAll = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-filter-view-all-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentsSidebarFilterLocation = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-filter-location-wireframe", __assign({}, remainingProps), children));
};
VeltCommentsSidebarFilterLocation.Name = VeltCommentsSidebarFilterName;
VeltCommentsSidebarFilterLocation.Item = VeltCommentsSidebarFilterItem;
VeltCommentsSidebarFilterLocation.ViewAll = VeltCommentsSidebarFilterViewAll;

var VeltCommentsSidebarFilterPeople = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-filter-people-wireframe", __assign({}, remainingProps), children));
};
VeltCommentsSidebarFilterPeople.Name = VeltCommentsSidebarFilterName;
VeltCommentsSidebarFilterPeople.Item = VeltCommentsSidebarFilterItem;

var VeltCommentsSidebarFilterPriority = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-filter-priority-wireframe", __assign({}, remainingProps), children));
};
VeltCommentsSidebarFilterPriority.Name = VeltCommentsSidebarFilterName;
VeltCommentsSidebarFilterPriority.Item = VeltCommentsSidebarFilterItem;

var VeltCommentsSidebarFilterTitle = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-filter-title-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentsSidebarFilterVersions = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-filter-versions-wireframe", __assign({}, remainingProps), children));
};
VeltCommentsSidebarFilterVersions.Name = VeltCommentsSidebarFilterName;
VeltCommentsSidebarFilterVersions.Item = VeltCommentsSidebarFilterItem;

var VeltCommentsSidebarFilter = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-filter-wireframe", __assign({}, remainingProps), children));
};
VeltCommentsSidebarFilter.Category = VeltCommentsSidebarFilterCategory;
VeltCommentsSidebarFilter.CloseButton = VeltCommentsSidebarFilterCloseButton;
VeltCommentsSidebarFilter.CommentType = VeltCommentsSidebarFilterCommentType;
VeltCommentsSidebarFilter.DoneButton = VeltCommentsSidebarFilterDoneButton;
VeltCommentsSidebarFilter.GroupBy = VeltCommentsSidebarFilterGroupBy;
VeltCommentsSidebarFilter.Location = VeltCommentsSidebarFilterLocation;
VeltCommentsSidebarFilter.People = VeltCommentsSidebarFilterPeople;
VeltCommentsSidebarFilter.Priority = VeltCommentsSidebarFilterPriority;
VeltCommentsSidebarFilter.Title = VeltCommentsSidebarFilterTitle;
VeltCommentsSidebarFilter.Versions = VeltCommentsSidebarFilterVersions;
VeltCommentsSidebarFilter.Item = VeltCommentsSidebarFilterItem;

var VeltCommentsSidebarHeader = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-header-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentsSidebarListItemDialogContainer = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-list-item-dialog-container-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentsSidebarListItemGroupCount = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-list-item-group-count-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentsSidebarListItemGroupArrow = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-list-item-group-arrow-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentsSidebarListItemGroupName = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-list-item-group-name-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentsSidebarListItemGroup = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-list-item-group-wireframe", __assign({}, remainingProps), children));
};
VeltCommentsSidebarListItemGroup.Count = VeltCommentsSidebarListItemGroupCount;
VeltCommentsSidebarListItemGroup.Arrow = VeltCommentsSidebarListItemGroupArrow;
VeltCommentsSidebarListItemGroup.Name = VeltCommentsSidebarListItemGroupName;

var VeltCommentsSidebarListItem = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-list-item-wireframe", __assign({}, remainingProps), children));
};
VeltCommentsSidebarListItem.Group = VeltCommentsSidebarListItemGroup;
VeltCommentsSidebarListItem.DialogContainer = VeltCommentsSidebarListItemDialogContainer;

var VeltCommentsSidebarList = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-list-wireframe", __assign({}, remainingProps), children));
};
VeltCommentsSidebarList.Item = VeltCommentsSidebarListItem;

var VeltCommentsSidebarPageModeComposer = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-page-mode-composer-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentsSidebarSearch = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-search-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentsSidebarStatusDropdownContentItemIconWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-status-dropdown-content-item-icon-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentsSidebarStatusDropdownContentItemNameWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-status-dropdown-content-item-name-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentsSidebarStatusDropdownContentItemCheckboxCheckedWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-status-dropdown-content-item-checkbox-checked-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentsSidebarStatusDropdownContentItemCheckboxUncheckedWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-status-dropdown-content-item-checkbox-unchecked-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentsSidebarStatusDropdownContentItemCheckboxWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-status-dropdown-content-item-checkbox-wireframe", __assign({}, remainingProps), children));
};
VeltCommentsSidebarStatusDropdownContentItemCheckboxWireframe.Checked = VeltCommentsSidebarStatusDropdownContentItemCheckboxCheckedWireframe;
VeltCommentsSidebarStatusDropdownContentItemCheckboxWireframe.Unchecked = VeltCommentsSidebarStatusDropdownContentItemCheckboxUncheckedWireframe;

var VeltCommentsSidebarStatusDropdownContentItemCountWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-status-dropdown-content-item-count-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentsSidebarStatusDropdownContentItemWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-status-dropdown-content-item-wireframe", __assign({}, remainingProp), children));
};
VeltCommentsSidebarStatusDropdownContentItemWireframe.Icon = VeltCommentsSidebarStatusDropdownContentItemIconWireframe;
VeltCommentsSidebarStatusDropdownContentItemWireframe.Name = VeltCommentsSidebarStatusDropdownContentItemNameWireframe;
VeltCommentsSidebarStatusDropdownContentItemWireframe.Count = VeltCommentsSidebarStatusDropdownContentItemCountWireframe;
VeltCommentsSidebarStatusDropdownContentItemWireframe.Checkbox = VeltCommentsSidebarStatusDropdownContentItemCheckboxWireframe;

var VeltCommentsSidebarStatusDropdownContentWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-status-dropdown-content-wireframe", __assign({}, remainingProp), children));
};
VeltCommentsSidebarStatusDropdownContentWireframe.Item = VeltCommentsSidebarStatusDropdownContentItemWireframe;

var VeltCommentsSidebarStatusDropdownTriggerArrowWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-status-dropdown-trigger-arrow-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentsSidebarStatusDropdownTriggerIndicatorWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-status-dropdown-trigger-indicator-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentsSidebarStatusDropdownTriggerNameWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-status-dropdown-trigger-name-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentsSidebarStatusDropdownTriggerWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-status-dropdown-trigger-wireframe", __assign({}, remainingProp), children));
};
VeltCommentsSidebarStatusDropdownTriggerWireframe.Arrow = VeltCommentsSidebarStatusDropdownTriggerArrowWireframe;
VeltCommentsSidebarStatusDropdownTriggerWireframe.Name = VeltCommentsSidebarStatusDropdownTriggerNameWireframe;
VeltCommentsSidebarStatusDropdownTriggerWireframe.Indicator = VeltCommentsSidebarStatusDropdownTriggerIndicatorWireframe;

var VeltCommentsSidebarStatus = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-status-wireframe", __assign({}, remainingProps), children));
};
VeltCommentsSidebarStatus.Trigger = VeltCommentsSidebarStatusDropdownTriggerWireframe;
VeltCommentsSidebarStatus.Content = VeltCommentsSidebarStatusDropdownContentWireframe;

var VeltCommentsSidebarFilterButton = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-filter-button-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentsSidebarSkeleton = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-skeleton-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentsSidebarPanel = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-panel-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentsSidebarWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-wireframe", __assign({}, remainingProp), children));
};
VeltCommentsSidebarWireframe.CloseButton = VeltCommentsSidebarCloseButton;
VeltCommentsSidebarWireframe.EmptyPlaceholder = VeltCommentsSidebarEmptyPlaceholder;
VeltCommentsSidebarWireframe.Filter = VeltCommentsSidebarFilter;
VeltCommentsSidebarWireframe.Header = VeltCommentsSidebarHeader;
VeltCommentsSidebarWireframe.List = VeltCommentsSidebarList;
VeltCommentsSidebarWireframe.PageModeComposer = VeltCommentsSidebarPageModeComposer;
VeltCommentsSidebarWireframe.Search = VeltCommentsSidebarSearch;
VeltCommentsSidebarWireframe.Status = VeltCommentsSidebarStatus;
VeltCommentsSidebarWireframe.FilterButton = VeltCommentsSidebarFilterButton;
VeltCommentsSidebarWireframe.Skeleton = VeltCommentsSidebarSkeleton;
VeltCommentsSidebarWireframe.Panel = VeltCommentsSidebarPanel;

var VeltCommentPinGhostCommentIndicator = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-pin-ghost-comment-indicator-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentPinIndex = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-pin-index-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentPinTriangle = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-pin-triangle-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentPinUnreadCommentIndicator = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-pin-unread-comment-indicator-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentPinPrivateCommentIndicator = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-pin-private-comment-indicator-wireframe", __assign({}, remainingProp), children));
};

var VeltCommentPinWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-pin-wireframe", __assign({}, remainingProp), children));
};
VeltCommentPinWireframe.GhostCommentIndicator = VeltCommentPinGhostCommentIndicator;
VeltCommentPinWireframe.Index = VeltCommentPinIndex;
VeltCommentPinWireframe.PrivateCommentIndicator = VeltCommentPinPrivateCommentIndicator;
VeltCommentPinWireframe.Triangle = VeltCommentPinTriangle;
VeltCommentPinWireframe.UnreadCommentIndicator = VeltCommentPinUnreadCommentIndicator;

var VeltSidebarButtonCommentsCount = function (props) {
    var children = props.children;
    return (React.createElement("velt-sidebar-button-comments-count-wireframe", null, children));
};

var VeltSidebarButtonIcon = function (props) {
    var children = props.children;
    return (React.createElement("velt-sidebar-button-icon-wireframe", null, children));
};

var VeltSidebarButtonWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-sidebar-button-wireframe", __assign({}, remainingProp), children));
};
VeltSidebarButtonWireframe.CommentsCount = VeltSidebarButtonCommentsCount;
VeltSidebarButtonWireframe.Icon = VeltSidebarButtonIcon;

var VeltCommentToolWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comment-tool-wireframe", __assign({}, remainingProps), children));
};

var VeltTextCommentToolWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-text-comment-tool-wireframe", __assign({}, remainingProps), children));
};

var VeltTextCommentToolbarCommentAnnotation = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-text-comment-toolbar-comment-annotation-wireframe", __assign({}, remainingProps), children));
};

var VeltTextCommentToolbarCopywriter = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-text-comment-toolbar-copywriter-wireframe", __assign({}, remainingProps), children));
};

var VeltTextCommentToolbarGeneric = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-text-comment-toolbar-generic-wireframe", __assign({}, remainingProps), children));
};

var VeltTextCommentToolbarDivider = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-text-comment-toolbar-divider-wireframe", __assign({}, remainingProps), children));
};

var VeltTextCommentToolbar = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-text-comment-toolbar-wireframe", __assign({}, remainingProps), children));
};
VeltTextCommentToolbar.CommentAnnotation = VeltTextCommentToolbarCommentAnnotation;
VeltTextCommentToolbar.Copywriter = VeltTextCommentToolbarCopywriter;
VeltTextCommentToolbar.Generic = VeltTextCommentToolbarGeneric;
VeltTextCommentToolbar.Divider = VeltTextCommentToolbarDivider;

var VeltUserSelectorDropdownAvatar = function (props) {
    var children = props.children;
    return (React.createElement("velt-user-selector-dropdown-avatar-wireframe", null, children));
};

var VeltUserSelectorDropdownEmail = function (props) {
    var children = props.children;
    return (React.createElement("velt-user-selector-dropdown-email-wireframe", null, children));
};

var VeltUserSelectorDropdownErrorIcon = function (props) {
    var children = props.children;
    return (React.createElement("velt-user-selector-dropdown-error-icon-wireframe", null, children));
};

var VeltUserSelectorDropdownName = function (props) {
    var children = props.children;
    return (React.createElement("velt-user-selector-dropdown-name-wireframe", null, children));
};

var VeltUserSelectorDropdown = function (props) {
    var children = props.children;
    return (React.createElement("velt-user-selector-dropdown-wireframe", null, children));
};
VeltUserSelectorDropdown.Avatar = VeltUserSelectorDropdownAvatar;
VeltUserSelectorDropdown.Email = VeltUserSelectorDropdownEmail;
VeltUserSelectorDropdown.ErrorIcon = VeltUserSelectorDropdownErrorIcon;
VeltUserSelectorDropdown.Name = VeltUserSelectorDropdownName;

var VeltAutocompleteOptionIconWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-autocomplete-option-icon-wireframe", __assign({}, remainingProp), children));
};

var VeltAutocompleteOptionNameWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-autocomplete-option-name-wireframe", __assign({}, remainingProp), children));
};

var VeltAutocompleteOptionDescriptionWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-autocomplete-option-description-wireframe", __assign({}, remainingProp), children));
};

var VeltAutocompleteOptionErrorIconWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-autocomplete-option-error-icon-wireframe", __assign({}, remainingProp), children));
};

var VeltAutocompleteOptionWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-autocomplete-option-wireframe", __assign({}, remainingProp), children));
};
VeltAutocompleteOptionWireframe.Icon = VeltAutocompleteOptionIconWireframe;
VeltAutocompleteOptionWireframe.Description = VeltAutocompleteOptionDescriptionWireframe;
VeltAutocompleteOptionWireframe.ErrorIcon = VeltAutocompleteOptionErrorIconWireframe;
VeltAutocompleteOptionWireframe.Name = VeltAutocompleteOptionNameWireframe;

var VeltAutocompleteChipTooltipDescriptionWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-autocomplete-chip-tooltip-description-wireframe", __assign({}, remainingProp), children));
};

var VeltAutocompleteChipTooltipIconWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-autocomplete-chip-tooltip-icon-wireframe", __assign({}, remainingProp), children));
};

var VeltAutocompleteChipTooltipNameWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-autocomplete-chip-tooltip-name-wireframe", __assign({}, remainingProp), children));
};

var VeltAutocompleteChipTooltipWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-autocomplete-chip-tooltip-wireframe", __assign({}, remainingProp), children));
};
VeltAutocompleteChipTooltipWireframe.Description = VeltAutocompleteChipTooltipDescriptionWireframe;
VeltAutocompleteChipTooltipWireframe.Icon = VeltAutocompleteChipTooltipIconWireframe;
VeltAutocompleteChipTooltipWireframe.Name = VeltAutocompleteChipTooltipNameWireframe;

var VeltCommentBubbleAvatar = function (props) {
    var children = props.children;
    return (React.createElement("velt-comment-bubble-avatar-wireframe", null, children));
};

var VeltCommentBubbleCommentsCount = function (props) {
    var children = props.children;
    return (React.createElement("velt-comment-bubble-comments-count-wireframe", null, children));
};

var VeltCommentBubbleWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-bubble-wireframe", __assign({}, remainingProp), children));
};
VeltCommentBubbleWireframe.Avatar = VeltCommentBubbleAvatar;
VeltCommentBubbleWireframe.CommentsCount = VeltCommentBubbleCommentsCount;

var VeltCommentsSidebarStatusDropdownWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-status-dropdown-wireframe", __assign({}, remainingProp), children));
};
VeltCommentsSidebarStatusDropdownWireframe.Trigger = VeltCommentsSidebarStatusDropdownTriggerWireframe;
VeltCommentsSidebarStatusDropdownWireframe.Content = VeltCommentsSidebarStatusDropdownContentWireframe;

var VeltReactionToolWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-reaction-tool-wireframe", __assign({}, remainingProp), children));
};

var VeltReactionPinCountWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-reaction-pin-count-wireframe", __assign({}, remainingProp), children));
};

var VeltReactionPinEmojiWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-reaction-pin-emoji-wireframe", __assign({}, remainingProp), children));
};

var VeltReactionPinWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-reaction-pin-wireframe", __assign({}, remainingProp), children));
};
VeltReactionPinWireframe.Emoji = VeltReactionPinEmojiWireframe;
VeltReactionPinWireframe.Count = VeltReactionPinCountWireframe;

var VeltReactionPinTooltipUserAvatarWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-reaction-pin-tooltip-user-avatar-wireframe", __assign({}, remainingProp), children));
};

var VeltReactionPinTooltipUserNameWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-reaction-pin-tooltip-user-name-wireframe", __assign({}, remainingProp), children));
};

var VeltReactionPinTooltipUserWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-reaction-pin-tooltip-user-wireframe", __assign({}, remainingProp), children));
};
VeltReactionPinTooltipUserWireframe.Avatar = VeltReactionPinTooltipUserAvatarWireframe;
VeltReactionPinTooltipUserWireframe.Name = VeltReactionPinTooltipUserNameWireframe;

var VeltReactionPinTooltipUsersWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-reaction-pin-tooltip-users-wireframe", __assign({}, remainingProp), children));
};
VeltReactionPinTooltipUsersWireframe.User = VeltReactionPinTooltipUserWireframe;

var VeltReactionPinTooltipWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-reaction-pin-tooltip-wireframe", __assign({}, remainingProp), children));
};
VeltReactionPinTooltipWireframe.Users = VeltReactionPinTooltipUsersWireframe;

var VeltReactionsPanelItemEmojiWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-reactions-panel-item-emoji-wireframe", __assign({}, remainingProp), children));
};

var VeltReactionsPanelItemWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-reactions-panel-item-wireframe", __assign({}, remainingProp), children));
};
VeltReactionsPanelItemWireframe.Emoji = VeltReactionsPanelItemEmojiWireframe;

var VeltReactionsPanelItemsWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-reactions-panel-items-wireframe", __assign({}, remainingProp), children));
};
VeltReactionsPanelItemsWireframe.Item = VeltReactionsPanelItemWireframe;

var VeltReactionsPanelWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-reactions-panel-wireframe", __assign({}, remainingProp), children));
};
VeltReactionsPanelWireframe.Items = VeltReactionsPanelItemsWireframe;

var VeltInlineCommentsSectionCommentCountWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-inline-comments-section-comment-count-wireframe", __assign({}, remainingProps), children));
};

var VeltInlineCommentsSectionComposerContainerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-inline-comments-section-composer-container-wireframe", __assign({}, remainingProps), children));
};

var VeltInlineCommentsSectionListWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-inline-comments-section-list-wireframe", __assign({}, remainingProps), children));
};

var VeltInlineCommentsSectionPanelWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-inline-comments-section-panel-wireframe", __assign({}, remainingProps), children));
};

var VeltInlineCommentsSectionSkeletonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-inline-comments-section-skeleton-wireframe", __assign({}, remainingProps), children));
};

var VeltInlineCommentsSectionWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-inline-comments-section-wireframe", __assign({}, remainingProps), children));
};
VeltInlineCommentsSectionWireframe.CommentCount = VeltInlineCommentsSectionCommentCountWireframe;
VeltInlineCommentsSectionWireframe.ComposerContainer = VeltInlineCommentsSectionComposerContainerWireframe;
VeltInlineCommentsSectionWireframe.List = VeltInlineCommentsSectionListWireframe;
VeltInlineCommentsSectionWireframe.Panel = VeltInlineCommentsSectionPanelWireframe;
VeltInlineCommentsSectionWireframe.Skeleton = VeltInlineCommentsSectionSkeletonWireframe;

function useClient() {
    var client = useVeltClient().client;
    var _a = React.useState(), veltClient = _a[0], setVeltClient = _a[1];
    React.useEffect(function () {
        if (!client || veltClient)
            return;
        setVeltClient(client);
    }, [client, setVeltClient, veltClient]);
    return veltClient;
}
function useIdentify(user, userOptions) {
    var client = useVeltClient().client;
    React.useEffect(function () {
        client && client.identify(user, userOptions);
    }, [client]);
}
function useSetDocumentId(documentId) {
    var client = useVeltClient().client;
    React.useEffect(function () {
        client && client.setDocumentId(documentId);
    }, [client]);
}
function useUnsetDocumentId() {
    var client = useVeltClient().client;
    React.useEffect(function () {
        client && client.unsetDocumentId && client.unsetDocumentId();
    }, [client]);
}
function useSetLocation(location, appendLocation) {
    var client = useVeltClient().client;
    React.useEffect(function () {
        client && client.setLocation(location, appendLocation);
    }, [client]);
}
function useVeltInitState() {
    var client = useVeltClient().client;
    var _a = React.useState(), data = _a[0], setData = _a[1];
    React.useEffect(function () {
        if (!(client === null || client === void 0 ? void 0 : client.getVeltInitState))
            return;
        var subscription = client === null || client === void 0 ? void 0 : client.getVeltInitState().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [client === null || client === void 0 ? void 0 : client.getVeltInitState]);
    return data;
}

function useCommentUtils() {
    var _a = React.useState(), commentElement = _a[0], setCommentElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || commentElement)
            return;
        var loadedCommentElement = client.getCommentElement();
        setCommentElement(loadedCommentElement);
    }, [client, setCommentElement, commentElement]);
    return commentElement;
}
function useCommentAnnotations(documentId, location) {
    var commentElement = useCommentUtils();
    var _a = React.useState([]), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getAllCommentAnnotations))
            return;
        var subscription = commentElement.getAllCommentAnnotations(documentId, location).subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.getAllCommentAnnotations]);
    return data;
}
function useUnreadCommentCountByAnnotationId(annotationId) {
    var commentElement = useCommentUtils();
    var _a = React.useState({ count: 0 }), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getUnreadCommentCountByAnnotationId))
            return;
        var subscription = commentElement.getUnreadCommentCountByAnnotationId(annotationId).subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.getUnreadCommentCountByAnnotationId]);
    return data;
}
function useUnreadCommentAnnotationCountOnCurrentDocument() {
    var commentElement = useCommentUtils();
    var _a = React.useState({ count: 0 }), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getUnreadCommentAnnotationCountOnCurrentDocument))
            return;
        var subscription = commentElement.getUnreadCommentAnnotationCountOnCurrentDocument().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.getUnreadCommentAnnotationCountOnCurrentDocument]);
    return data;
}
function useUnreadCommentCountOnCurrentDocument() {
    var commentElement = useCommentUtils();
    var _a = React.useState({ count: 0 }), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getUnreadCommentCountOnCurrentDocument))
            return;
        var subscription = commentElement.getUnreadCommentCountOnCurrentDocument().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.getUnreadCommentCountOnCurrentDocument]);
    return data;
}
function useUnreadCommentCountByLocationId(locationId) {
    var commentElement = useCommentUtils();
    var _a = React.useState({ count: 0 }), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getUnreadCommentCountByLocationId))
            return;
        var subscription = commentElement.getUnreadCommentCountByLocationId(locationId).subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.getUnreadCommentCountByLocationId]);
    return data;
}
function useUnreadCommentAnnotationCountByLocationId(locationId) {
    var commentElement = useCommentUtils();
    var _a = React.useState({ count: 0 }), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getUnreadCommentAnnotationCountByLocationId))
            return;
        var subscription = commentElement.getUnreadCommentAnnotationCountByLocationId(locationId).subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.getUnreadCommentAnnotationCountByLocationId]);
    return data;
}
function useCommentModeState() {
    var commentElement = useCommentUtils();
    var _a = React.useState(), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentModeChange))
            return;
        var subscription = commentElement.onCommentModeChange().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentModeChange]);
    return data;
}
function useCommentAddHandler() {
    var commentElement = useCommentUtils();
    var _a = React.useState(), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentAdd))
            return;
        var subscription = commentElement.onCommentAdd().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentAdd]);
    return data;
}
function useCommentUpdateHandler() {
    var commentElement = useCommentUtils();
    var _a = React.useState(), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentUpdate))
            return;
        var subscription = commentElement.onCommentUpdate().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentUpdate]);
    return data;
}
function useCommentDialogSidebarClickHandler() {
    var commentElement = useCommentUtils();
    var _a = React.useState(), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.onSidebarButtonOnCommentDialogClick))
            return;
        var subscription = commentElement.onSidebarButtonOnCommentDialogClick().subscribe(function (res) {
            setData(res === undefined ? new Date().getTime() : res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.onSidebarButtonOnCommentDialogClick]);
    return data;
}
function useCommentSelectionChangeHandler() {
    var commentElement = useCommentUtils();
    var _a = React.useState(), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentSelectionChange))
            return;
        var subscription = commentElement.onCommentSelectionChange().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentSelectionChange]);
    return data;
}

function useCursorUtils() {
    var _a = React.useState(), cursorElement = _a[0], setCursorElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || cursorElement)
            return;
        var loadedCursorElement = client.getCursorElement();
        setCursorElement(loadedCursorElement);
    }, [client, setCursorElement, cursorElement]);
    return cursorElement;
}
function useCursorUsers() {
    var cursorElement = useCursorUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!cursorElement)
            return;
        var subscription = cursorElement.getOnlineUsersOnCurrentDocument().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [cursorElement]);
    return data;
}

function useHuddleUtils() {
    var _a = React.useState(), huddleElement = _a[0], setHuddleElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || huddleElement)
            return;
        var loadedHuddleElement = client.getHuddleElement();
        setHuddleElement(loadedHuddleElement);
    }, [client, setHuddleElement, huddleElement]);
    return huddleElement;
}

function useLiveStateSyncUtils() {
    var _a = React.useState(), liveStateSyncElement = _a[0], setLiveStateSyncElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || liveStateSyncElement)
            return;
        var loadedLiveStateSyncElement = client.getLiveStateSyncElement();
        setLiveStateSyncElement(loadedLiveStateSyncElement);
    }, [client, setLiveStateSyncElement, liveStateSyncElement]);
    return liveStateSyncElement;
}
function useLiveStateData(liveStateDataId, liveStateDataConfig) {
    var liveStateSyncElement = useLiveStateSyncUtils();
    var _a = React.useState(), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.getLiveStateData))
            return;
        var subscription = liveStateSyncElement.getLiveStateData(liveStateDataId, liveStateDataConfig).subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.getLiveStateData]);
    return data;
}
function useSetLiveStateData(liveStateDataId, liveStateData) {
    var liveStateSyncElement = useLiveStateSyncUtils();
    React.useEffect(function () {
        if (liveStateSyncElement && liveStateDataId && liveStateData) {
            liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.setLiveStateData(liveStateDataId, liveStateData);
        }
    }, [liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.setLiveStateData]);
}
function useUserEditorState() {
    var liveStateSyncElement = useLiveStateSyncUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.isUserEditor))
            return;
        var subscription = liveStateSyncElement.isUserEditor().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.isUserEditor]);
    return data;
}
function useEditor() {
    var liveStateSyncElement = useLiveStateSyncUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.getEditor))
            return;
        var subscription = liveStateSyncElement.getEditor().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.getEditor]);
    return data;
}
function useEditorAccessTimer() {
    var liveStateSyncElement = useLiveStateSyncUtils();
    var _a = React.useState({ state: 'idle' }), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.getEditorAccessTimer))
            return;
        var subscription = liveStateSyncElement.getEditorAccessTimer().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.getEditorAccessTimer]);
    return data;
}
function useEditorAccessRequestHandler() {
    var liveStateSyncElement = useLiveStateSyncUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.isEditorAccessRequested))
            return;
        var subscription = liveStateSyncElement.isEditorAccessRequested().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.isEditorAccessRequested]);
    return data;
}
function useServerConnectionStateChangeHandler() {
    var liveStateSyncElement = useLiveStateSyncUtils();
    var _a = React.useState(), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.onServerConnectionStateChange))
            return;
        var subscription = liveStateSyncElement.onServerConnectionStateChange().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.onServerConnectionStateChange]);
    return data;
}
function useLiveState(liveStateDataId, initialValue, options) {
    var liveStateSyncElement = useLiveStateSyncUtils();
    var client = useVeltClient().client;
    var serverConnectionState = useServerConnectionStateChangeHandler();
    var _a = React.useState(null), documentId = _a[0], setDocumentId = _a[1];
    var _b = React.useState(null), user = _b[0], setUser = _b[1];
    var _c = React.useState(initialValue), data = _c[0], setData = _c[1];
    useEffect(function () {
        resetLiveStateData();
    }, [documentId, user]);
    var resetLiveStateData = function () {
        if (user && documentId) {
            liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.setLiveStateData(liveStateDataId, data);
        }
    };
    useEffect(function () {
        if (!(liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.getLiveStateData))
            return;
        var documentPathsSubscription, userSubscription;
        if (options === null || options === void 0 ? void 0 : options.resetLiveState) {
            documentPathsSubscription = client.docService.getDocumentPaths$().subscribe(function (paths) {
                if (paths) {
                    setDocumentId(paths === null || paths === void 0 ? void 0 : paths.documentId);
                    documentPathsSubscription === null || documentPathsSubscription === void 0 ? void 0 : documentPathsSubscription.unsubscribe();
                }
            });
            userSubscription = client.authService.getUser$().subscribe(function (user) {
                if (user) {
                    setUser(user);
                    userSubscription === null || userSubscription === void 0 ? void 0 : userSubscription.unsubscribe();
                }
            });
        }
        var subscription = liveStateSyncElement.getLiveStateData(liveStateDataId, { listenToNewChangesOnly: options === null || options === void 0 ? void 0 : options.listenToNewChangesOnly }).subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
            documentPathsSubscription === null || documentPathsSubscription === void 0 ? void 0 : documentPathsSubscription.unsubscribe();
            userSubscription === null || userSubscription === void 0 ? void 0 : userSubscription.unsubscribe();
        };
    }, [liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.getLiveStateData]);
    var useDebounce = function (callback) {
        var callbackRef = useRef(callback);
        var timerRef = useRef(null);
        useEffect(function () {
            callbackRef.current = callback;
        });
        var debounce = function (value, delay) {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
            timerRef.current = setTimeout(function () {
                callbackRef.current(value);
            }, delay);
        };
        return debounce;
    };
    var setDataFunction = function (value) {
        setData(value);
        debouncedOnInput(value, (options === null || options === void 0 ? void 0 : options.syncDuration) >= 0 ? options === null || options === void 0 ? void 0 : options.syncDuration : 50); // default 50ms debounce time
    };
    var debouncedOnInput = useDebounce(function (value) {
        if (liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.setLiveStateData) {
            liveStateSyncElement.setLiveStateData(liveStateDataId, value);
        }
    });
    return [data, setDataFunction, serverConnectionState];
}

function usePresenceUtils() {
    var _a = React.useState(), presenceElement = _a[0], setPresenceElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || presenceElement)
            return;
        var loadedPresenceElement = client.getPresenceElement();
        setPresenceElement(loadedPresenceElement);
    }, [client, setPresenceElement, presenceElement]);
    return presenceElement;
}
function usePresenceUsers() {
    var presenceElement = usePresenceUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!presenceElement)
            return;
        var subscription = presenceElement.getOnlineUsersOnCurrentDocument().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [presenceElement]);
    return data;
}

function useRecorderUtils() {
    var _a = React.useState(), recorderElement = _a[0], setRecorderElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || recorderElement)
            return;
        var loadedRecorderElement = client.getRecorderElement();
        setRecorderElement(loadedRecorderElement);
    }, [client, setRecorderElement, recorderElement]);
    return recorderElement;
}
function useRecorderAddHandler() {
    var recorderElement = useRecorderUtils();
    var _a = React.useState(), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!recorderElement)
            return;
        var subscription = recorderElement.onRecordedData().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [recorderElement]);
    return data;
}

function useAIRewriterUtils() {
    var _a = React.useState(), rewriterElement = _a[0], setRewriterElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || rewriterElement)
            return;
        var loadedRewriterElement = client.getRewriterElement();
        setRewriterElement(loadedRewriterElement);
    }, [client, setRewriterElement, rewriterElement]);
    return rewriterElement;
}

function useLiveSelectionUtils() {
    var _a = React.useState(), selectionElement = _a[0], setSelectionElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || selectionElement)
            return;
        var loadedSelectionElement = client.getSelectionElement();
        setSelectionElement(loadedSelectionElement);
    }, [client, setSelectionElement, selectionElement]);
    return selectionElement;
}

function useTagUtils() {
    var _a = React.useState(), tagElement = _a[0], setTagElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || tagElement)
            return;
        var loadedTagElement = client.getTagElement();
        setTagElement(loadedTagElement);
    }, [client, setTagElement, tagElement]);
    return tagElement;
}
function useTagAnnotations(documentId, location) {
    var tagElement = useTagUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!tagElement)
            return;
        var subscription = tagElement.getAllTagAnnotations(documentId, location).subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [tagElement]);
    return data;
}

function useViewsUtils() {
    var _a = React.useState(), viewsElement = _a[0], setViewsElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || viewsElement)
            return;
        var loadedViewsElement = client.getViewsElement();
        setViewsElement(loadedViewsElement);
    }, [client, setViewsElement, viewsElement]);
    return viewsElement;
}
function useUniqueViewsByUser(clientLocationId) {
    var viewsElement = useViewsUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(viewsElement === null || viewsElement === void 0 ? void 0 : viewsElement.getUniqueViewsByUser))
            return;
        var subscription = viewsElement.getUniqueViewsByUser(clientLocationId).subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [viewsElement === null || viewsElement === void 0 ? void 0 : viewsElement.getUniqueViewsByUser]);
    return data;
}
function useUniqueViewsByDate(clientLocationId) {
    var viewsElement = useViewsUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(viewsElement === null || viewsElement === void 0 ? void 0 : viewsElement.getUniqueViewsByDate))
            return;
        var subscription = viewsElement.getUniqueViewsByDate(clientLocationId).subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [viewsElement === null || viewsElement === void 0 ? void 0 : viewsElement.getUniqueViewsByDate]);
    return data;
}

function useNotificationUtils() {
    var _a = React.useState(), notificationElement = _a[0], setNotificationElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || notificationElement)
            return;
        var loadedNotificationElement = client.getNotificationElement();
        setNotificationElement(loadedNotificationElement);
    }, [client, setNotificationElement, notificationElement]);
    return notificationElement;
}
function useNotificationsData() {
    var notificationElement = useNotificationUtils();
    var _a = React.useState([]), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(notificationElement === null || notificationElement === void 0 ? void 0 : notificationElement.getNotificationsData))
            return;
        var subscription = notificationElement.getNotificationsData().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [notificationElement === null || notificationElement === void 0 ? void 0 : notificationElement.getNotificationsData]);
    return data;
}

function useAutocompleteUtils() {
    var _a = React.useState(), autocompleteElement = _a[0], setAutocompleteElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || autocompleteElement)
            return;
        var loadedAutocompleteElement = client.getAutocompleteElement();
        setAutocompleteElement(loadedAutocompleteElement);
    }, [client, setAutocompleteElement, autocompleteElement]);
    return autocompleteElement;
}
function useAutocompleteChipClick() {
    var autocompleteElement = useAutocompleteUtils();
    var _a = React.useState(), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!autocompleteElement)
            return;
        var subscription = autocompleteElement.onAutocompleteChipClick().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [autocompleteElement]);
    return data;
}

function useContactUtils() {
    var _a = React.useState(), contactElement = _a[0], setContactElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || contactElement)
            return;
        var loadedContactElement = client.getContactElement();
        setContactElement(loadedContactElement);
    }, [client, setContactElement, contactElement]);
    return contactElement;
}
function useContactSelected() {
    var contactElement = useContactUtils();
    var _a = React.useState(), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!contactElement)
            return;
        var subscription = contactElement.onContactSelected().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [contactElement === null || contactElement === void 0 ? void 0 : contactElement.onContactSelected]);
    return data;
}

var sessionId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
var getSessionId = function () {
    return (sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(VELT_TAB_ID)) || sessionId;
};
var VELT_DEFAULT_LIVE_STATE_ID = 'velt-default-redux-live-state';
var createLiveStateMiddleware = function (config) {
    if (config === void 0) { config = {}; }
    var _a = config.allowedActionTypes, allowedActionTypes = _a === void 0 ? new Set() : _a, // Set of allowed action types for sync
    _b = config.disabledActionTypes, // Set of allowed action types for sync
    disabledActionTypes = _b === void 0 ? new Set() : _b, // Set of disabled action types for sync
    _c = config.allowAction, // Set of disabled action types for sync
    allowAction = _c === void 0 ? function () { return true; } : _c, // Callback to decide if an action should sync with live state
    _d = config.liveStateDataId, // Callback to decide if an action should sync with live state
    liveStateDataId = _d === void 0 ? VELT_DEFAULT_LIVE_STATE_ID : _d;
    if (!liveStateDataId) {
        liveStateDataId = VELT_DEFAULT_LIVE_STATE_ID;
    }
    var internalStore; // This variable will hold the reference to the store
    var dataSubscription; // This variable will hold the reference to the data subscription
    var isSdkInitialized = false;
    var setupGetDataSubscription = function () {
        var _a, _b;
        if (!dataSubscription && window.Velt && ((_a = window.Velt) === null || _a === void 0 ? void 0 : _a.getLiveStateSyncElement)) {
            var liveStateSyncElement = (_b = window.Velt) === null || _b === void 0 ? void 0 : _b.getLiveStateSyncElement();
            dataSubscription = liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.getLiveStateData(liveStateDataId).subscribe(function (data) {
                // Dispatch action to update local state, marking it as remote
                if (data) {
                    var sessionId_1 = getSessionId();
                    if (data.id === sessionId_1) {
                        return;
                    }
                    else {
                        internalStore === null || internalStore === void 0 ? void 0 : internalStore.dispatch(__assign(__assign({}, data.action), { isRemote: true }));
                    }
                }
            });
        }
    };
    var updateLiveStateDataId = function (newId) {
        liveStateDataId = newId || VELT_DEFAULT_LIVE_STATE_ID;
        if (dataSubscription) {
            dataSubscription.unsubscribe();
            dataSubscription = null;
        }
        if (isSdkInitialized) {
            setupGetDataSubscription();
        }
    };
    var middleware = function (store) {
        internalStore = store;
        var veltSdkInitializedListener = function () {
            isSdkInitialized = true;
            setupGetDataSubscription();
            // Remove the event listener after it's triggered
            window.removeEventListener(VELT_SDK_INIT_EVENT, veltSdkInitializedListener);
        };
        // Add the event listener for the veltSdkInitialized event
        window.addEventListener(VELT_SDK_INIT_EVENT, veltSdkInitializedListener);
        return function (next) { return function (action) {
            // Always process the action locally
            var result = next(action);
            // Decide whether to sync this action with Firebase
            if (isSdkInitialized && !action.isRemote && allowAction(action) && !disabledActionTypes.has(action.type) && (allowedActionTypes.size === 0 || allowedActionTypes.has(action.type))) {
                logLiveState(action, liveStateDataId);
            }
            return result;
        }; };
    };
    return {
        middleware: middleware,
        updateLiveStateDataId: updateLiveStateDataId,
    };
};
var logLiveState = function (action, liveStateDataId) {
    var _a;
    if (window.Velt) {
        var sessionId_2 = getSessionId();
        var liveStateElement = (_a = window === null || window === void 0 ? void 0 : window.Velt) === null || _a === void 0 ? void 0 : _a.getLiveStateSyncElement();
        if (liveStateElement === null || liveStateElement === void 0 ? void 0 : liveStateElement.setLiveStateData) {
            liveStateElement.setLiveStateData(liveStateDataId, {
                id: sessionId_2,
                action: action
            });
        }
        liveStateElement.setLiveStateData(liveStateDataId, {
            id: sessionId_2,
            action: action
        });
    }
};

export { SnippylyArrowTool as VeltArrowTool, SnippylyArrows as VeltArrows, VeltAutocomplete, VeltAutocompleteChipTooltipWireframe, VeltAutocompleteOptionWireframe, VeltCanvasComment, VeltChartComment, SnippylyCommentBubble as VeltCommentBubble, VeltCommentBubbleWireframe, VeltCommentDialogOptionsDropdownContentWireframe, VeltCommentDialogOptionsDropdownTriggerWireframe, VeltCommentDialogPriorityDropdownContentWireframe, VeltCommentDialogPriorityDropdownTriggerWireframe, VeltCommentDialogStatusDropdownContentWireframe, VeltCommentDialogStatusDropdownTriggerWireframe, VeltCommentDialogWireframe, VeltCommentPin, VeltCommentPinWireframe, VeltCommentPlayerTimeline, VeltCommentThread, SnippylyCommentTool as VeltCommentTool, VeltCommentToolWireframe, SnippylyComments as VeltComments, SnippylyCommentsSidebar as VeltCommentsSidebar, VeltCommentsSidebarStatusDropdownWireframe, VeltCommentsSidebarWireframe, SnippylyCursor as VeltCursor, VeltHighChartComments, SnippylyHuddle as VeltHuddle, SnippylyHuddleTool as VeltHuddleTool, VeltInlineCommentsSection, VeltInlineCommentsSectionWireframe, VeltNivoChartComments, VeltNotificationsHistoryPanel, VeltNotificationsPanel, VeltNotificationsTool, SnippylyPresence as VeltPresence, SnippylyProvider as VeltProvider, VeltReactionPinTooltipWireframe, VeltReactionPinWireframe, VeltReactionToolWireframe, VeltReactionsPanelWireframe, SnippylyRecorderControlPanel as VeltRecorderControlPanel, SnippylyRecorderNotes as VeltRecorderNotes, SnippylyRecorderPlayer as VeltRecorderPlayer, SnippylyRecorderTool as VeltRecorderTool, SnippylySidebarButton as VeltSidebarButton, VeltSidebarButtonWireframe, SnippylyTagTool as VeltTagTool, SnippylyTags as VeltTags, VeltTextCommentToolWireframe, VeltTextCommentToolbar as VeltTextCommentToolbarWireframe, SnippylyUserInviteTool as VeltUserInviteTool, SnippylyUserRequestTool as VeltUserRequestTool, VeltUserSelectorDropdown as VeltUserSelectorDropdownWireframe, VeltVideoPlayer, VeltViewAnalytics, VeltWireframe, createLiveStateMiddleware, useAIRewriterUtils, useAutocompleteChipClick, useAutocompleteUtils, useClient, useCommentAddHandler, useCommentAnnotations, useCommentDialogSidebarClickHandler, useCommentModeState, useCommentSelectionChangeHandler, useCommentUpdateHandler, useCommentUtils, useContactSelected, useContactUtils, useCursorUsers, useCursorUtils, useEditor, useEditorAccessRequestHandler, useEditorAccessTimer, useHuddleUtils, useIdentify, useLiveSelectionUtils, useLiveState, useLiveStateData, useLiveStateSyncUtils, useNotificationUtils, useNotificationsData, usePresenceUsers, usePresenceUtils, useRecorderAddHandler, useRecorderUtils, useServerConnectionStateChangeHandler, useSetDocumentId, useSetLiveStateData, useSetLocation, useTagAnnotations, useTagUtils, useUniqueViewsByDate, useUniqueViewsByUser, useUnreadCommentAnnotationCountByLocationId, useUnreadCommentAnnotationCountOnCurrentDocument, useUnreadCommentCountByAnnotationId, useUnreadCommentCountByLocationId, useUnreadCommentCountOnCurrentDocument, useUnsetDocumentId, useUserEditorState, useVeltClient, useVeltInitState, useViewsUtils };
//# sourceMappingURL=index.js.map
